import React, { useState, useEffect } from 'react';
import { useAuth } from '../Context/AuthContext';
import { toast } from 'react-toastify';
import CustomCloseButton from '../Components/CustomCloseButton';

import { Container, Row, Col, Modal, Button, Form } from 'react-bootstrap';
import { timestampToHTMLDateInput, /*HTMLDateInputToTimestamp,*/ currentTimeStamp } from '../HelperFunctions/dateConverters';

import { db } from '../firebase-config';
import { /*doc, runTransaction,*/ query, where, collection, getDocs } from 'firebase/firestore';

import { jsPDF } from "jspdf";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus, faCircleMinus } from '@fortawesome/free-solid-svg-icons';

import { inputMaxLengths } from '../HelperFunctions/InputMaxLengths';

const RequestModal = (props) =>{
    const { setShowSpinner, currentUser } = useAuth();

    const [custName, setCustName] = useState("");
    const [serviceAt, setServiceAt] = useState("");
    const [custPhoneNo, setCustPhoneNo] = useState("");
    const [custEmail, setCustEmail] = useState("");
    const [requestType, setRequestType] = useState("");
    const [typeOfService, setTypeOfService] = useState("");
    const [requestDetails, setRequestDetails] = useState("");
    const [workOrderNo, setWorkOrderNo] = useState("");
    const [customer, setCustomer] = useState("");
    const [customerPurchaseOrder, setCustomerPurchaseOrder] = useState("");
    const [scheduledDate, setScheduledDate] = useState("");
    const [scheduledPriority, setScheduledPriority] =  useState(10);
    const [assignedTechnicians, setAssignedTechnicians] = useState([]);
    const [leadTech, setLeadTech] = useState("");
    const [units, setUnits] = useState([]);
    const [materials, setMaterials] = useState([]);
    const [workCompleted, setWorkCompleted] = useState(false);
    const [dateCompleted, setDateCompleted] = useState("");
    const [truckCharge, setTruckCharge] = useState(0.00);
    const [invoiceNumber, setInvoiceNumber] = useState("");

    const [displayPrintOptions, setDisplayPrintOptions] = useState(false);
    const [printInvoiceNumber, setPrintInvoiceNumber] = useState(false);
    const [printQuoteNumber, setPrintQuoteNumber] = useState(true);
    const [printMaterials, setPrintMaterials] = useState(true);
    const [printMaterialCharges, setPrintMaterialCharges] = useState(true);
    const [printTruckCharge, setPrintTruckCharge] = useState(true);
    const [printHours, setPrintHours] = useState(true);

    const [quoteNo, setQuoteNo] = useState("");
    const [quoteAmount, setQuoteAmount] = useState(0.00);

    const [hours, setHours] = useState([]);

    const [techToAddHours, setTechToAddHours] = useState("");

    const [emailTooltip, setEmailTooltip] = useState('');

    const [technicians, setTechnicians] = useState([]);
    const [updateOrderButtonStatus, setUpdateOrderButtonStatus] = useState('edit');  // edit or save

    const emailReg = /[A-Za-z0-9._+-]+@[A-Za-z0-9 -]+\.[a-z]{2,}/g;

    useEffect(()=>{
        setShowSpinner(true);
        let tempTechnicians = [];
        // also get access none, for historical workorders
        const q = query(collection(db, "technicians"), where("access", "in", ["technician", "inactive"]));
        getDocs(q).then((querySnapshot)=>{
        //getDocs(collection(db, "technicians")).then((querySnapshot)=>{
            setShowSpinner(false);
            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                tempTechnicians = [...tempTechnicians, {id: doc.id, data: doc.data()}];
            });
            console.log(tempTechnicians)
        }).then(()=>{
            setTechnicians(tempTechnicians);
        }).catch((error)=>{
            setShowSpinner(false);
            toast.error(`Failed to load data: ${error.message}`);
        });
    }, [setShowSpinner]);

    useEffect(()=>{
      setCustName(props?.request?.data?.work_order?.cust_auth_contact === undefined ? props?.request?.data?.["client name"] === undefined ? "" : props?.request?.data?.["client name"] : props?.request?.data?.work_order?.cust_auth_contact);
      setServiceAt(props?.request?.data?.work_order?.service_at === undefined ? props?.request?.data?.address === undefined ? "" : props.request.data.address : props?.request?.data?.work_order?.service_at);
      setCustPhoneNo(props?.request?.data?.work_order?.phone_number === undefined ? props?.request?.data?.['phone number'] === undefined ? "" : props?.request?.data?.['phone number'] : props?.request?.data?.work_order?.phone_number);
      setCustEmail(props?.request?.data?.work_order?.email_address === undefined ? props?.request?.data?.['email address'] === undefined ? "" : props?.request?.data?.['email address'] : props?.request?.data?.work_order?.email_address);
      setRequestType(props?.request?.data?.work_order?.request_type === undefined ? props?.request?.data?.type === undefined ? "" : props?.request?.data?.type : props?.request?.data?.work_order?.request_type);
      setTypeOfService(props?.request?.data?.work_order?.type_of_service === undefined ? props?.request?.data?.['type of service'] === undefined ? "" : props?.request?.data?.['type of service'] : props?.request?.data?.work_order?.type_of_service);
      setRequestDetails(props?.request?.data?.work_order?.details === undefined ? props?.request?.data?.details === undefined ? "" : props?.request?.data?.details : props?.request?.data?.work_order?.details);
      setWorkOrderNo(props?.request?.data?.work_order?.order_number === undefined ? '' : props?.request?.data?.work_order?.order_number);
      setCustomer(props?.request?.data?.work_order?.customer === undefined ? '' : props?.request?.data?.work_order?.customer);
      setCustomerPurchaseOrder(props?.request?.data?.work_order?.customer_purchase_order === undefined ? '' : props?.request?.data?.work_order?.customer_purchase_order);
      setScheduledDate(props?.request?.data?.work_order?.scheduled_date === undefined ? "" : timestampToHTMLDateInput(props?.request?.data?.work_order?.scheduled_date));
      setScheduledPriority(props?.request?.data?.work_order?.priority === undefined ? 10 : props?.request?.data?.work_order?.priority);
      setAssignedTechnicians(props?.request?.data?.work_order?.assigned_techs === undefined ? [] : props?.request?.data?.work_order?.assigned_techs);
      setLeadTech(props?.request?.data?.work_order?.lead_tech === undefined ? '' : props?.request?.data?.work_order?.lead_tech);
      setUnits(props?.request?.data?.work_order?.units === undefined ? [] : props?.request?.data?.work_order?.units);
      setMaterials(props?.request?.data?.work_order?.materials === undefined ? [] : props?.request?.data?.work_order?.materials);
      setWorkCompleted(props?.request?.data?.status === undefined ? false : props.request.data.status > 3 ? true : false);
      setDateCompleted(props?.request?.data?.complete_timestamp === undefined ? "" : timestampToHTMLDateInput(props.request.data.complete_timestamp));
      setTruckCharge(props?.request?.data?.work_order?.truck_charge === undefined ? 0.00 : props.request.data.work_order.truck_charge)
      setHours(props?.currentworkorderhours === undefined ?  [] : props.currentworkorderhours);
      setInvoiceNumber(props?.request?.data?.invoice_number === undefined ? '' : props?.request?.data?.invoice_number);
      setQuoteNo(props?.request?.data?.work_order?.quote_number === undefined ? '' : props?.request?.data?.work_order?.quote_number);
      setQuoteAmount(props?.request?.data?.work_order?.quote_amount === undefined ||  props?.request?.data?.work_order?.quote_amount === "" ? 0.00 : props?.request?.data?.work_order?.quote_amount);
      setPrintInvoiceNumber(props?.request?.data?.print_invoice_number === undefined ? false : props?.request?.data?.print_invoice_number);
      setPrintQuoteNumber(props?.request?.data?.print_quote_number === undefined ? false : props?.request?.data?.print_quote_number);
      setPrintMaterials(props?.request?.data?.print_materials === undefined ? false : props?.request?.data?.print_materials);
      setPrintMaterialCharges(props?.request?.data?.print_material_charges === undefined ? false : props?.request?.data?.print_material_charges);
      setPrintTruckCharge(props?.request?.data?.print_truck_charge === undefined ? false : props?.request?.data?.print_truck_charge);
      setPrintHours(props?.request?.data?.print_hours === undefined ? false : props?.request?.data?.print_hours);
    },[props]);
/*
    const invoiced = ()=>{
      // save the status of how it was printed
      // with quote, with truck charge, with hours, with materials, auto/manual calculated
      setShowSpinner(true);
        const requestRef = doc(db, "invoiced_work_orders", props.request.id);
        runTransaction(db, async (transaction)=>{
            // load, save new, delete
            const requestDoc = await transaction.get(requestRef);

            if(!requestDoc.exists()){
                throw new Error("Request document does not exist");
            }
            let tempData = {...requestDoc.data(),
                status: 6,
                print_invoice_number : printInvoiceNumber,
                print_quote_number: printQuoteNumber,
                print_materials: printMaterials,
                print_material_charges: printMaterialCharges,
                print_truck_charge: printTruckCharge,
                print_hours: printHours,
                invoice_number: invoiceNumber,
            }

            let techDocs = [];
            if(requestDoc?.data()?.work_order?.assigned_techs !== undefined && requestDoc.data().work_order.assigned_techs.length > 0){
                const assignedTechnicians = requestDoc.data().work_order.assigned_techs;
                for(let x=0; x < assignedTechnicians.length; ++x){
                    techDocs[x] = await transaction.get(doc(db, "technicians", assignedTechnicians[x]));
                    if(!techDocs[x].exists()){
                        throw new Error("Technician document does not exist");
                    }
                }
            }

            await transaction.set(doc(db, 'invoiced_work_orders/', requestDoc.id), tempData);
            await transaction.delete(requestRef);

            // remove if de-selected the tech
            for(let x=0; x<techDocs.length; ++x){
                let newTechDoc = techDocs[x].data();
                // console.log(newTechDoc);
                const indexOfId = newTechDoc.work_orders.findIndex(e => e.id === requestDoc.id);
                if(indexOfId > -1){
                    newTechDoc.work_orders.splice(indexOfId, 1);
                }// if doesn't exist then don't need to remove
                await transaction.update(doc(db, "technicians", techDocs[x].id), newTechDoc);
            }
            return tempData;
        }).then((newState)=>{
            // clean up
            setShowSpinner(false);
            toast.success(`WO: ${props?.request?.data?.work_order?.order_number} has been invoiced.`);
            setDisplayPrintOptions(false);
            setPrintInvoiceNumber(false);
            setPrintQuoteNumber(true);
            setPrintMaterials(true);
            setPrintMaterialCharges(true);
            setPrintTruckCharge(true);
            setPrintHours(true);
            props.onHide();
        }).catch((error)=>{
            setShowSpinner(false);
            setDisplayPrintOptions(false);
            setPrintInvoiceNumber(false);
            setPrintQuoteNumber(true);
            setPrintMaterials(true);
            setPrintMaterialCharges(true);
            setPrintTruckCharge(true);
            setPrintHours(true);
            props.onHide('show cancel');
            toast.error(`Failed to save data: ${error.message}`);
        });
    }

*/
    const printWorkOrder = ()=>{
      setShowSpinner(true);
      import('../Assets/provenIconBase64').then(({provenIconBase64})=>{
        setShowSpinner(false);

        let today = new Date();
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        const yyyy = today.getFullYear();
        // const hh = today.getHours();
        // const min = today.getMinutes();

        const todaysDate = yyyy + "-" + mm + "-" + dd;

        const doc = new jsPDF("l", "mm", "letter");

        let letterPage = {
          // letter  = 215.9mm x 279.4mm portrait
          // letter = 279.4mm x215.9mm landscape
          // legal = 215.9mm x 355.6mm portait
          // paperWidth: 215.9,
          // paperHeight: 279.4,
          paperWidth: 279.4,
          paperHeight: 215.9,
          margin: 10,
          tab: 4,
          indent: 8,
          nextY: 10,
          nextX: 7,
          pageNumber: 1,
          axisPointOne: null,
          axisPointTwo: null,
          axisPointThree: null,
          textSpacer: 6.425,
          incrementPageNumber: (number) =>{
            letterPage.pageNumber += number;
          },
          enter: () => {
            letterPage.nextY += doc.getFontSize() / 2;
            letterPage.nextX = 7;
          },
          addEmptyLine: ()=>{
            letterPage.nextY += doc.getFontSize()/1.25;
          },
          deleteEnter: () =>{
            letterPage.nextY -= doc.getFontSize() /2;
          },
          centerText: () => {
            return letterPage.paperWidth / 2;
          },
          checkAddPage: () => {
            letterPage.nextY = letterPage.nextY + doc.getFontSize() / 2;
            if (letterPage.nextY >= letterPage.paperHeight - 20) {
              doc.addPage("letter", "p");
              letterPage.incrementPageNumber(1);
              letterPage.nextY = letterPage.margin;
              doc.text(
                new Date().toDateString(),
                letterPage.paperWidth - letterPage.margin,
                letterPage.nextY,
                { align: "right" }
              );
              letterPage.nextY = letterPage.nextY + doc.getFontSize() / 2;
            }
          },
          checkAddPagePic: (heightOfPic) => {
            letterPage.nextY = letterPage.nextY + heightOfPic + doc.getFontSize() / 2;
            if (letterPage.nextY >= letterPage.paperHeight - 20) {
              doc.addPage("letter", "p");
              letterPage.incrementPageNumber(1);
              letterPage.nextY = letterPage.margin;
              doc.text(
                new Date().toDateString(),
                letterPage.paperWidth - letterPage.margin,
                letterPage.nextY,
                { align: "right" }
              );
              letterPage.nextY = letterPage.nextY + doc.getFontSize() / 2;
            }
          },
          preCheckAddPagePic: (heightOfPic)=>{
            if ((letterPage.nextY + heightOfPic + doc.getFontSize()) >= letterPage.paperHeight - letterPage.margin) {
              doc.addPage("letter", "p");
              letterPage.incrementPageNumber(1);
              letterPage.nextY = letterPage.margin;
              doc.text(
                new Date().toDateString(),
                letterPage.paperWidth - letterPage.margin,
                letterPage.nextY,
                { align: "right" }
              );
              letterPage.nextY = letterPage.nextY + doc.getFontSize() / 2;
            }
          },
          setAxisPointOne: (point)=>{
            letterPage.axisPointOne = point;
          },
          setAxisPointTwo: (point)=>{
            letterPage.axisPointTwo = point;
          },
          setAxisPointThree: (point)=>{
            letterPage.axisPointThree = point;
          },
          drawOutline:()=>{
            doc.lines([[(letterPage.paperWidth-letterPage.margin),0],[0, (letterPage.paperHeight-letterPage.margin)],[-(letterPage.paperWidth-letterPage.margin), 0]], letterPage.margin-5,letterPage.margin-5, [1,1], 'S', true);
            doc.text('WHITE - CONTROL COPY  \u2022  YELLOW - SERVICE COPY  \u2022  PINK - CUSTOMER COPY', letterPage.margin-5, letterPage.paperHeight-letterPage.margin+((letterPage.margin*1.5)/2));
          },
          drawMaterialGrid: ()=>{
            let verticalLines = [];
            let horizontalLines = [letterPage.nextY-(doc.getFontSize()/2)-1];
            
            doc.text('SOURCE', letterPage.nextX, letterPage.nextY);
            letterPage.nextX += doc.getTextWidth('SOURCE')+letterPage.tab;
            verticalLines.push((letterPage.nextX-(letterPage.tab/2)));
            
            doc.text('QTY.', letterPage.nextX, letterPage.nextY);
            letterPage.nextX += doc.getTextWidth('QTY.')+letterPage.tab;
            verticalLines.push((letterPage.nextX-(letterPage.tab/2)));
            
            doc.text('MATERIAL DESCRIPTION', letterPage.nextX, letterPage.nextY);
            letterPage.nextX += doc.getTextWidth('MATERIAL DESCRIPTION')+(letterPage.tab*4);
            verticalLines.push((letterPage.nextX-(letterPage.tab*2)));
            
            doc.text('PRICE', letterPage.nextX, letterPage.nextY);
            letterPage.nextX += doc.getTextWidth('PRICE')+(letterPage.tab*4);
            verticalLines.push((letterPage.nextX-(letterPage.tab*2)));
            
            letterPage.enter();
            horizontalLines.push((letterPage.nextY -= letterPage.tab/2));
            
            for(let x=0; x<21; ++x){
              letterPage.addEmptyLine();
              horizontalLines.push(letterPage.nextY);
            }
            
            // draw vertical lines
            verticalLines.forEach((vertLine)=>{
              doc.line(vertLine, horizontalLines[0], vertLine, horizontalLines[horizontalLines.length-1], 'S');
            });
            
            // draw split price vertical line
            doc.line(verticalLines[verticalLines.length-1]-9, horizontalLines[1], verticalLines[verticalLines.length-1]-9, horizontalLines[horizontalLines.length-1], 'S');
            
            // draw horizontal line
            horizontalLines.forEach((horLine)=>{
              doc.line(letterPage.margin-5, horLine, verticalLines[verticalLines.length-1], horLine, 'S');
            });
            
            letterPage.setAxisPointOne(verticalLines[verticalLines.length-1]);
            letterPage.setAxisPointTwo(verticalLines[verticalLines.length-1]-9);
            letterPage.setAxisPointThree(verticalLines[verticalLines.length-2]);
          },
          drawMaterialChargesGrid: ()=>{
            // let verticalLines = [];
            let horizontalLines = [letterPage.nextY];
            
            for(let x=0; x<4; ++x){
              letterPage.addEmptyLine();
              horizontalLines.push(letterPage.nextY);
            }
            
            //draw vertical lines
            doc.line(letterPage.axisPointOne, horizontalLines[0], letterPage.axisPointOne, horizontalLines[horizontalLines.length-1], 'S');
            doc.line(letterPage.axisPointTwo, horizontalLines[0], letterPage.axisPointTwo, horizontalLines[horizontalLines.length-1], 'S');
            doc.line(letterPage.axisPointThree, horizontalLines[0], letterPage.axisPointThree, horizontalLines[horizontalLines.length-1], 'S');
            
            // draw horizontal line
            horizontalLines.forEach((horLine)=>{
              doc.line(letterPage.margin-5, horLine, letterPage.axisPointOne, horLine, 'S');
            });
            
            doc.text('TRUCK CHARGE',6,150.925);
            doc.text('TOTAL MATERIAL',6,157.35);
            doc.text('TOTAL LABOUR',6,163.775);
            doc.text('WORK ORDER TOTAL (please see official invoice)',6,170.2);
            doc.text('plus HST',101,170.2);
            doc.setTextColor(255,0,0);
            if(quoteNo !== "" && printQuoteNumber){
              doc.text(`QUOTE: ${quoteNo}`, 116, 170.2); // max length 20
            }
            if(invoiceNumber !== "" && printInvoiceNumber){
              doc.text(`INVOICE #: ${invoiceNumber}`, letterPage.centerText()-(doc.getTextWidth(`INVOICE #: ${invoiceNumber}`)/2), 3.5);
            }
            doc.setTextColor(0,0,0);
          },
          drawTechLabourGrid: ()=>{
            let tempAxisPoint = letterPage.axisPointOne+20;
            let tempAxisPointSpacer = 11;
            let verticalLines = 7;
            let horizontalLines = [letterPage.nextY];
            
            for(let x=0; x<5; ++x){
              letterPage.addEmptyLine();
              horizontalLines.push(letterPage.nextY);
            }
            
            // draw horizontal lines
            horizontalLines.forEach((horLine)=>{
              doc.line(letterPage.margin-5, horLine, tempAxisPoint, horLine, 'S');
            });
            
            // draw vertical lines
            for(let x=0; x<verticalLines; ++x){
              doc.line(tempAxisPoint-(x*tempAxisPointSpacer), horizontalLines[0], tempAxisPoint-(x*tempAxisPointSpacer), letterPage.paperHeight-letterPage.margin+((letterPage.margin*1.5)/3), 'S');
            }
            
            doc.text('NAME',6,176.625);
            doc.text('MON.',55.5,176.625);
            doc.text('TUE.',66.5,176.625);
            doc.text('WED.',77.5,176.625);
            doc.text('THU.',88.5,176.625);
            doc.text('FRI.',99.5,176.625);
            doc.text('SAT.',110.5,174.625);
            doc.text('SUN.',110.5,177.625);
          },
          drawTitleGrid: (xOffset=0)=>{
            doc.line(225, 5, 225, 31.2, 'S');
            doc.line(letterPage.axisPointOne-xOffset, 31.2, letterPage.paperWidth-5, 31.2, 'S');
            doc.line(225, 18, letterPage.paperWidth-5, 18, 'S');
            doc.text('WORK ORDER No:', 226, 8);
            doc.text('DATE:', 226, 21.125);
            
            // image size is 1635x682
            doc.addImage(provenIconBase64, 'PNG', letterPage.axisPointOne+0.5-xOffset, 6.5, 1635/35, 682/35);
            doc.setTextColor(152,152,152);
            doc.text("M E C H A N I C A L  S E R V I C E S", letterPage.axisPointOne+0.75-xOffset, 26);
            doc.setTextColor(0,0,0);
            doc.setFontSize(9);
            doc.text("The Proven Group Inc.", letterPage.axisPointOne+50-xOffset, 9);
            doc.text("118 Sandiford Drive, Unit 7", letterPage.axisPointOne+50-xOffset, 13);
            doc.text("Stouffville, Ontario  L4A 3V9", letterPage.axisPointOne+50-xOffset, 17);
            doc.text("Phone 905-640-0440  \u2022  Fax 905-640-0443", letterPage.axisPointOne+50-xOffset, 23);
            doc.text("Toll Free 1-877-944-9276  \u2022  Fax 1-877-943-9276", letterPage.axisPointOne+50-xOffset, 27);
            doc.setFontSize(8);
          },
          drawHorizontalMainGrid: ()=>{
            for(let x=4; x<8; ++x){
              doc.line(letterPage.axisPointOne, 31.2+(doc.getFontSize()/1.25*x), letterPage.paperWidth-5, 31.2+(doc.getFontSize()/1.25*x), 'S');
            }
          },
          drawHorizontalUnitGrid: (xOffset=0, yOffset=0)=>{
            for(let x=8; x<23; ++x){
              doc.line(letterPage.axisPointOne-xOffset, 31.2+(doc.getFontSize()/1.25*x)-yOffset, letterPage.paperWidth-5, 31.2+(doc.getFontSize()/1.25*x)-yOffset, 'S');
            }
          },
          drawServiceInfoGrid: ()=>{
            doc.text('CUSTOMER:', letterPage.axisPointOne+2, 37.2);
            doc.text('SERVICE AT:', (letterPage.paperWidth-5+letterPage.axisPointOne+2)/2, 37.2);
            
            for(let x=0; x<4; ++x){
              doc.line(letterPage.axisPointOne+2, 38.2+(doc.getFontSize()/1.4*x), ((letterPage.paperWidth-5+letterPage.axisPointOne+2)/2)-4, 38.2+(doc.getFontSize()/1.4*x));
              doc.line((letterPage.paperWidth-5+letterPage.axisPointOne+2)/2, 38.2+(doc.getFontSize()/1.4*x), letterPage.paperWidth-9, 38.2+(doc.getFontSize()/1.4*x));
            }
            
            doc.text('CUST. PHONE No.', letterPage.axisPointOne+2, 34+(doc.getFontSize()/1.25*4));
            doc.line(letterPage.axisPointOne+46, 31.2+(doc.getFontSize()/1.25*4), letterPage.axisPointOne+46, 31.2+(doc.getFontSize()/1.25*5), 'S');
            doc.text('CUST. AUTHORIZATION/CONTACT', letterPage.axisPointOne+47, 34+(doc.getFontSize()/1.25*4));
            doc.line(letterPage.axisPointOne+126, 31.2+(doc.getFontSize()/1.25*4), letterPage.axisPointOne+126, 31.2+(doc.getFontSize()/1.25*5), 'S');
            doc.text('CUSTOMER PURCHASE ORDER', letterPage.axisPointOne+127, 34+(doc.getFontSize()/1.25*4));
            
            doc.text('SERVICE REQUIRED', letterPage.axisPointOne+2, 34+(doc.getFontSize()/1.25*5));
            
            doc.text('WORK COMPLETED   YES   NO', letterPage.axisPointOne+127, 34+(doc.getFontSize()/1.25*21)+2);
          },
          drawUnitDescriptionGrid: (xOffset=0, yOffset=0)=>{
            doc.text('MAKE', letterPage.axisPointOne+2-xOffset, 34+(doc.getFontSize()/1.25*7)-yOffset);
            doc.line(letterPage.axisPointOne+56-xOffset, 31.2+(doc.getFontSize()/1.25*7)-yOffset, letterPage.axisPointOne+56-xOffset, 31.2+(doc.getFontSize()/1.25*8)-yOffset, 'S');
            doc.text('MODEL', letterPage.axisPointOne+57-xOffset, 34+(doc.getFontSize()/1.25*7)-yOffset);
            doc.line(letterPage.axisPointOne+113-xOffset, 31.2+(doc.getFontSize()/1.25*7)-yOffset, letterPage.axisPointOne+113-xOffset, 31.2+(doc.getFontSize()/1.25*8)-yOffset, 'S');
            doc.text('SERIAL', letterPage.axisPointOne+114-xOffset, 34+(doc.getFontSize()/1.25*7)-yOffset);
            
            doc.text('DESCRIPTION OF', letterPage.axisPointOne+2-xOffset, 34+(doc.getFontSize()/1.25*8)-yOffset);
            doc.text('WORK PERFORMED', letterPage.axisPointOne+2-xOffset, 34+(doc.getFontSize()/1.25*8)+3-yOffset);
            doc.text('SERVICE', letterPage.axisPointOne+2-xOffset, 34+(doc.getFontSize()/1.25*17-yOffset));
            doc.text('RECOMMENDED', letterPage.axisPointOne+2-xOffset, 34+(doc.getFontSize()/1.25*17)+3-yOffset);
          },
          drawSignatureGrid: ()=>{
            doc.setFontSize(6.8)
            doc.text('UPON SIGNING THIS REPORT THE CUSTOMER AGREES TO PAY THE PROVEN GROUP IN FULL FOR ALL MATERIALS AND LABOUR', letterPage.axisPointOne+21, 176);
            doc.text('LISTED ABOVE. THE CUSTOMER ALSO AGREES TO PAY THE PROVEN GROUP IN FULL FOR ALL ADDITIONAL EXPENSES INCCURED', letterPage.axisPointOne+21, 180);
            doc.text('IN CONNECTION WITH THIS REPORT AND IN ACCORDANCE WITH THE RATES AND PRICES IN EFFECT AS OF THIS DATE, AS', letterPage.axisPointOne+21, 184);
            doc.text('DETERMINED BY THE PROVEN GROUP. PAYMENT IN FULL MUST BE MADE WITHIN 30 DAYS FO THIS DATE. INTEREST WILL BE', letterPage.axisPointOne+21, 188);
            doc.text('CHARGED AT THE RATE OF 2% PER MONTH ON OVERDUE ACCOUNTS. UPON SIGNING THIS REPORT THE CUSTOMER', letterPage.axisPointOne+21, 192);
            doc.text('ACKNOWLEDGES RECEIPT OF ALL MATERIALS, LABOUR, AND OTHER CHARGES AS DESCRIBED ABOVE.', letterPage.axisPointOne+21, 196);
            doc.setFontSize(8)
            doc.text("Customer's Signature", letterPage.axisPointOne+21, letterPage.paperHeight-letterPage.margin+3);
            doc.line(letterPage.axisPointOne+51, letterPage.paperHeight-letterPage.margin+3, letterPage.paperWidth-10, letterPage.paperHeight-letterPage.margin+3);
          },
          formatTextForPrinting: (text)=>{
            const charactersPerLine = 100; // Change this value according to your requirement
            let formattedText = '';
            let charCount = 0;

            const words = text.split(' ');
            for (const word of words) {
                // Check if adding the current word exceeds the charactersPerPage limit
                if (charCount + word.length + 1 > charactersPerLine) {
                    formattedText += '\n'; // Move to the next line
                    charCount = 0; // Reset character count for the new line
                }
  
                formattedText += word + ' '; // Add word with a space
  
                charCount += word.length + 1; // Increment character count including space
  
                if (word.includes('\n')){
                    const breakArray = word.split('\n');
                    charCount = breakArray[breakArray.length-1].length;
                }
            }
            return formattedText;
          },
          stringToProcess: (stringToBeProcessed)=>{
            // 8x90 = 720 | 720-8 (\n) = 712
            // 3x90 = 270 | 270-3 (\n) = 267
            const lines = letterPage.formatTextForPrinting(stringToBeProcessed).split('\n');
  
            return lines;
          },
          fillOutForm: ()=>{
            // console.log(currentWorkOrder);
            doc.setFontSize(9);
            doc.setTextColor(0,0,255);
            doc.setDrawColor(0,0,255);
            
            doc.text(workOrderNo, 226, 14);
            doc.text(dateCompleted === "" ? todaysDate : dateCompleted, 226, 27.125);
            
            doc.text(customer,letterPage.axisPointOne+2, 36.9+(doc.getFontSize()/1.4*1));
            doc.text(serviceAt,(letterPage.paperWidth-5+letterPage.axisPointOne+2)/2, 36.9+(doc.getFontSize()/1.4*1));
            
            doc.text(custPhoneNo, letterPage.axisPointOne+2, 34+(doc.getFontSize()/1.25*4));
            doc.text(custName, letterPage.axisPointOne+47, 34+(doc.getFontSize()/1.25*4));
            doc.text(customerPurchaseOrder, letterPage.axisPointOne+127, 34+(doc.getFontSize()/1.25*4));
            
            doc.text(`${(requestType).toUpperCase()} ${typeOfService !== "" ? '-' : ""} ${typeOfService}`,letterPage.axisPointOne+34, 32+(doc.getFontSize()/1.25*5)); 
            doc.text(requestDetails.split('\n').join('.'), letterPage.axisPointOne+2, 38+(doc.getFontSize()/1.25*5));
            
            if(units?.length > 0){
              doc.text(units[units.length-1]?.Make, letterPage.axisPointOne+10, 38+(doc.getFontSize()/1.25*6));
              doc.text(units[units.length-1]?.Model, letterPage.axisPointOne+67, 38+(doc.getFontSize()/1.25*6));
              doc.text(units[units.length-1]?.Serial, letterPage.axisPointOne+125, 38+(doc.getFontSize()/1.25*6));	
            }

            if(workCompleted){
              doc.ellipse(258.75,169.25,4,2.5, 'S');
            }else{
              doc.ellipse(266,169.25,4,2.5, 'S');
            }
            
            // // image size is 1635x682
            // doc.addImage(signatureBase64, 'PNG', letterPage.axisPointOne+55, 197, 2363/60, 1216/60);
            // doc.setFontSize(19);
            // console.log(doc.getFontList());
            // doc.setFont('times', 'italic');
            // doc.text(custName, letterPage.axisPointOne+55, 208);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(9);
            
              // // Material grid
              // // row 1, col 1 = 5.1,16, 10 chars (SOURCE)
              // // row += 6.425
              // // col QTY start = 22, 6 chars
              // // col MATERIAL DESCRIPTION start = 32, 25 chars
              // // col PRICE dollars start = 80, 6 chars
              // // col PRICE cents start = 94, 2 chars
            let materialTotalCost = 0.00;
            if(printMaterials || printMaterialCharges){
              const materialGridWriteUpXBoxes = [5.1,22,32,80,94];
              const materialGridWriteUpY = 16
              const materialGridWriteUpYMultiplyer = 6.425;
              
              for (let item=materials.length-1; item>=0; --item){
                // materials.forEach((item, index)=>{
                let cost = parseFloat(materials[item].Price);
                if(materials[item]?.Price === undefined){materials[item].Price = "" };
                if(materials[item].Price === ""){ cost = 0 };
                if(printMaterialCharges){
                  materialTotalCost += cost;
                }
                doc.text(materials[item].Source,materialGridWriteUpXBoxes[0],(item*materialGridWriteUpYMultiplyer)+materialGridWriteUpY);
                doc.text(materials[item].Qty,materialGridWriteUpXBoxes[1],(item*materialGridWriteUpYMultiplyer)+materialGridWriteUpY);
                doc.text(materials[item]["Material Description"], materialGridWriteUpXBoxes[2], (item*materialGridWriteUpYMultiplyer)+materialGridWriteUpY);
                
                if(printMaterialCharges){
                  let dollars = materials[item].Price.split('.')[0] !== undefined ? materials[item].Price.split('.')[0].toString() : "0";
                  if(dollars.length === 0){ dollars = "0" };
                  
                  let cents = materials[item].Price.split('.')[1] !== undefined ? materials[item].Price.split('.')[1].toString() : "00";
                  if(cents.length === 1){ cents = `${cents}0` };
                  
                  doc.text(dollars, materialGridWriteUpXBoxes[3], (item*materialGridWriteUpYMultiplyer)+materialGridWriteUpY);
                  doc.text(cents, materialGridWriteUpXBoxes[4], (item*materialGridWriteUpYMultiplyer)+materialGridWriteUpY);
                }
              }//);
              // material charges
              if(printMaterialCharges){
                materialTotalCost = Math.round(materialTotalCost*100)/100;
                let materialTotalCostDollars = materialTotalCost.toString().split('.')[0] !== undefined ? materialTotalCost.toString().split('.')[0] : "0";
                if(materialTotalCostDollars.length === 0) { materialTotalCostDollars = "0" };
                
                let materialTotalCostCents = materialTotalCost.toString().split('.')[1] !== undefined ? materialTotalCost.toString().split('.')[1] : "00";
                if(materialTotalCostCents.length === 1){ materialTotalCostCents = `${materialTotalCostCents}0` };
                
                doc.text(materialTotalCostDollars,80,157.35);
                doc.text(materialTotalCostCents,94,157.35);
              }
              // end material charges
            }
            
            // truckCharges
            if(printTruckCharge){
              let truckChargeTemp = Math.round(truckCharge*100)/100;
              let truckChargeDollars = truckChargeTemp.toString().split('.')[0] !== undefined ? truckChargeTemp.toString().split('.')[0] : "0";
              if(truckChargeDollars.length === 0) { truckChargeDollars = "0" };
              
              let truckChargeCents = truckChargeTemp.toString().split('.')[1] !== undefined ? truckChargeTemp.toString().split('.')[1] : "00";
              if(truckChargeCents.length === 1) { truckChargeCents = `${truckChargeCents}0` };
              doc.text(truckChargeDollars, 80, 150.925);
              doc.text(truckChargeCents, 94, 150.925);
            }
            // end TruckCharges
            
            // tech labour
            let totalLabour = 0;
            if(printHours){
              const techGridYStart = 183.05;
              const techGridXBoxes = [6, 55.5, 66.5, 77.5, 88.5, 99.5, 110.5];
              // console.log(assignedTechnicians)
              // console.log(hours);
              let indexReducer = 0;
              hours.forEach((tech, index)=>{
                if(assignedTechnicians.includes(tech.techID)){
                  index = index - indexReducer;
                  doc.text(technicians.find(searchTech=>searchTech.id === tech.techID).data.tech_name,techGridXBoxes[0],techGridYStart+(index*letterPage.textSpacer));
                  
                  doc.text(tech?.Monday !== undefined ? tech.Monday : "",techGridXBoxes[1],techGridYStart+(index*letterPage.textSpacer));
                  doc.text(tech?.Tuesday !== undefined ? tech.Tuesday : "",techGridXBoxes[2],techGridYStart+(index*letterPage.textSpacer));
                  doc.text(tech?.Wednesday !== undefined ? tech.Wednesday : "",techGridXBoxes[3],techGridYStart+(index*letterPage.textSpacer));
                  doc.text(tech?.Thursday !== undefined ? tech.Thursday : "",techGridXBoxes[4],techGridYStart+(index*letterPage.textSpacer));
                  doc.text(tech?.Friday !== undefined ? tech.Friday : "",techGridXBoxes[5],techGridYStart+(index*letterPage.textSpacer));
                  
                  let monday = tech?.Monday !== undefined && tech?.Monday !== "" ? parseFloat(tech.Monday) : 0;
                  let mondayPremium = tech?.Premium_Monday !== undefined && tech?.Premium_Monday !== "" ? parseFloat(tech.Premium_Monday) : 0;
                  let tuesday = tech?.Tuesday !== undefined && tech?.Tuesday !== "" ? parseFloat(tech.Tuesday) : 0;
                  let tuesdayPremium = tech?.Premium_Tuesday !== undefined && tech?.Premium_Tuesday !== "" ? parseFloat(tech.Premium_Tuesday) : 0;
                  let wednesday = tech?.Wednesday !== undefined && tech?.Wednesday !== "" ? parseFloat(tech?.Wednesday) : 0;
                  let wednesdayPremium = tech?.Premium_Wednesday !== undefined && tech?.Premium_Wednesday !== "" ? parseFloat(tech?.Premium_Wednesday) : 0;
                  let thursday = tech?.Thursday !== undefined && tech?.Thursday !== "" ? parseFloat(tech?.Thursday) : 0;
                  let thursdayPremium = tech?.Premium_Thursday !== undefined && tech?.Premium_Thursday !== "" ? parseFloat(tech?.Premium_Thursday) : 0;
                  let friday = tech?.Friday !== undefined && tech?.Friday !== "" ? parseFloat(tech?.Friday) : 0;
                  let fridayPremium = tech?.Premium_Friday !== undefined && tech?.Premium_Friday !== "" ? parseFloat(tech?.Premium_Friday) : 0;

                  let saturday = tech?.Saturday !== undefined && tech?.Saturday !== "" ? parseFloat(tech?.Saturday) : 0;
                  let sunday = tech?.Sunday !== undefined && tech?.Sunday !== "" ? parseFloat(tech?.Sunday) : 0;
                  let saturdayPremium = tech?.Premium_Saturday !== undefined && tech?.Premium_Saturday !== "" ? parseFloat(tech?.Premium_Saturday) : 0;
                  let sundayPremium = tech?.Premium_Sunday !== undefined && tech?.Premium_Sunday !== "" ? parseFloat(tech?.Premium_Sunday) : 0;
                  
                  doc.text(saturday+sunday > 0 ? (Math.round((saturday+sunday)*100)/100).toString() : "",techGridXBoxes[6],techGridYStart+(index*letterPage.textSpacer));
                  
                  let mondayRate = tech?.["Monday Rate"] !== undefined && tech?.["Monday Rate"] !== "" ? parseFloat(tech?.["Monday Rate"]) : 0;
                  let tuesdayRate = tech?.["Tuesday Rate"] !== undefined && tech?.["Tuesday Rate"] !== "" ? parseFloat(tech?.["Tuesday Rate"]) : 0;
                  let wednesdayRate = tech?.["Wednesday Rate"] !== undefined && tech?.["Wednesday Rate"] !== "" ? parseFloat(tech?.["Wednesday Rate"]) : 0;
                  let thursdayRate = tech?.["Thursday Rate"] !== undefined && tech?.["Thursday Rate"] !== "" ? parseFloat(tech?.["Thursday Rate"]) : 0;
                  let fridayRate = tech?.["Friday Rate"] !== undefined && tech?.["Friday Rate"] !== "" ? parseFloat(tech?.["Friday Rate"]) : 0;
                  let saturdayRate = tech?.["Saturday Rate"] !== undefined && tech?.["Saturday Rate"] !== "" ? parseFloat(tech?.["Saturday Rate"]) : 0;
                  let sundayRate = tech?.["Sunday Rate"] !== undefined && tech?.["Sunday Rate"] !== "" ? parseFloat(tech?.["Sunday Rate"]) : 0;
                  
                  let mondayPremiumRate = tech?.["Premium Monday Rate"] !== undefined && tech?.["Premium Monday Rate"] !== "" ? parseFloat(tech?.["Premium Monday Rate"]) : 0;
                  let tuesdayPremiumRate = tech?.["Premium Tuesday Rate"] !== undefined && tech?.["Premium Tuesday Rate"] !== "" ? parseFloat(tech?.["Premium Tuesday Rate"]) : 0;
                  let wednesdayPremiumRate = tech?.["Premium Wednesday Rate"] !== undefined && tech?.["Premium Wednesday Rate"] !== "" ? parseFloat(tech?.["Premium Wednesday Rate"]) : 0;
                  let thursdayPremiumRate = tech?.["Premium Thursday Rate"] !== undefined && tech?.["Premium Thursday Rate"] !== "" ? parseFloat(tech?.["Premium Thursday Rate"]) : 0;
                  let fridayPremiumRate = tech?.["Premium Friday Rate"] !== undefined && tech?.["Premium Friday Rate"] !== "" ? parseFloat(tech?.["Premium Friday Rate"]) : 0;
                  let saturdayPremiumRate = tech?.["Premium Saturday Rate"] !== undefined && tech?.["Premium Saturday Rate"] !== "" ? parseFloat(tech?.["Premium Saturday Rate"]) : 0;
                  let sundayPremiumRate = tech?.["Premium Sunday Rate"] !== undefined && tech?.["Premium Sunday Rate"] !== "" ? parseFloat(tech?.["Premium Sunday Rate"]) : 0;

                  totalLabour += ((monday-mondayPremium) * mondayRate) + (mondayPremium * mondayPremiumRate);
                  totalLabour += ((tuesday-tuesdayPremium) * tuesdayRate) + (tuesdayPremium * tuesdayPremiumRate);
                  totalLabour += ((wednesday-wednesdayPremium) * wednesdayRate) + (wednesdayPremium * wednesdayPremiumRate);
                  totalLabour += ((thursday-thursdayPremium) * thursdayRate) + (thursdayPremium * thursdayPremiumRate);
                  totalLabour += ((friday-fridayPremium) * fridayRate) + (fridayPremium * fridayPremiumRate);
                  totalLabour += ((saturday-saturdayPremium) * saturdayRate) + (saturdayPremium * saturdayPremiumRate);
                  totalLabour += ((sunday-sundayPremium) * sundayRate) + (sundayPremium * sundayPremiumRate);
                }else{
                  indexReducer++;
                }
              });
              // end tech labour
              // labour charges
              let labourCharge = Math.round(totalLabour*100)/100;
              let labourChargeDollars = labourCharge.toString().split('.')[0] !== undefined ? labourCharge.toString().split('.')[0] : "0";
              if(labourChargeDollars.length === 0) { labourChargeDollars = "0" };
              
              let labourChargeCents = labourCharge.toString().split('.')[1] !== undefined ? labourCharge.toString().split('.')[1] : "00";
              if(labourChargeCents.length === 1) { labourChargeCents = `${labourChargeCents}0` };
              
              doc.text(labourChargeDollars,80,163.775);
              doc.text(labourChargeCents,94,163.775);
              // end labour charges
            } else{
              const techGridYStart = 183.05;
              const techGridXBoxes = [6, 55.5, 66.5, 77.5, 88.5, 99.5, 110.5];

              hours.forEach((tech, index)=>{
                if(assignedTechnicians.includes(tech.techID)){
                  doc.text(technicians.find(searchTech=>searchTech.id === tech.techID).data.tech_name,techGridXBoxes[0],techGridYStart+(index*letterPage.textSpacer));

                  let monday = tech?.Monday !== undefined && tech?.Monday !== "" ? parseFloat(tech.Monday) : 0;
                  let tuesday = tech?.Tuesday !== undefined && tech?.Tuesday !== "" ? parseFloat(tech.Tuesday) : 0;
                  let wednesday = tech?.Wednesday !== undefined && tech?.Wednesday !== "" ? parseFloat(tech?.Wednesday) : 0;
                  let thursday = tech?.Thursday !== undefined && tech?.Thursday !== "" ? parseFloat(tech?.Thursday) : 0;
                  let friday = tech?.Friday !== undefined && tech?.Friday !== "" ? parseFloat(tech?.Friday) : 0;
                  
                  let saturday = tech?.Saturday !== undefined && tech?.Saturday !== "" ? parseFloat(tech?.Saturday) : 0;
                  let sunday = tech?.Sunday !== undefined && tech?.Sunday !== "" ? parseFloat(tech?.Sunday) : 0;
                    
                  doc.text(monday > 0 ? "X" : "",techGridXBoxes[1],techGridYStart+(index*letterPage.textSpacer));
                  doc.text(tuesday > 0 ? "X" : "",techGridXBoxes[2],techGridYStart+(index*letterPage.textSpacer));
                  doc.text(wednesday > 0 ? "X" : "",techGridXBoxes[3],techGridYStart+(index*letterPage.textSpacer));
                  doc.text(thursday > 0 ? "X" : "",techGridXBoxes[4],techGridYStart+(index*letterPage.textSpacer));
                  doc.text(friday > 0  ? "X" : "",techGridXBoxes[5],techGridYStart+(index*letterPage.textSpacer));

                  doc.text(saturday+sunday > 0 ? "X" : "",techGridXBoxes[6],techGridYStart+(index*letterPage.textSpacer));
                }
              });
                
            }
            
            // total invoice
            const variableTruckCharge = printTruckCharge ? truckCharge : 0.00;
            let totalInvoice = 0.00;
            if(printQuoteNumber){
              totalInvoice = Math.round((quoteAmount + totalLabour + materialTotalCost + variableTruckCharge)*100)/100;
            }else{
              totalInvoice = Math.round((totalLabour + materialTotalCost + variableTruckCharge)*100)/100;
            }
            let totalInvoiceDollars = totalInvoice.toString().split('.')[0] !== undefined ? totalInvoice.toString().split('.')[0] : "0";
            if(totalInvoiceDollars.length === 0) { totalInvoiceDollars = "0" };
              
            let totalInvoiceCents = totalInvoice.toString().split('.')[1] !== undefined ? totalInvoice.toString().split('.')[1] : "00";
            if(totalInvoiceCents.length === 1){ totalInvoiceCents = `${totalInvoiceCents}0` };
              
            doc.text(totalInvoiceDollars,80,170.2);
            doc.text(totalInvoiceCents,94,170.2);
            // end total invoice

            let workingPage = 1;
            let pageCount = 1;
            // DO HERE IN CASE THERE ARE MULTIPLE PAGES
            letterPage.stringToProcess(units[units.length-1]?.["Description of Work Performed"]).forEach((line, index)=>{
              if (index !== 0 && index % 8 === 0) { // Create a new page for every 8 lines
                doc.addPage("letter", "l");
                doc.setFontSize(8);
                doc.setTextColor(0,0,0);
                doc.setDrawColor(0,0,0);
                letterPage.drawOutline();
                letterPage.drawTitleGrid(90);
                letterPage.drawHorizontalUnitGrid(90, 45);
                letterPage.drawUnitDescriptionGrid(90, 45);
                
                doc.setFontSize(9);
                doc.setTextColor(0,0,255);
                doc.setDrawColor(0,0,255);

                if(units?.length > 0){
                  doc.text(units[units.length-1]?.Make, letterPage.axisPointOne+10-90, 38+(doc.getFontSize()/1.25*6)-45);
                  doc.text(units[units.length-1]?.Model, letterPage.axisPointOne+67-90, 38+(doc.getFontSize()/1.25*6)-45);
                  doc.text(`${units[units.length-1]?.Serial}  -> CONTINUED...`, letterPage.axisPointOne+125-90, 38+(doc.getFontSize()/1.25*6)-45);
                }

                doc.text(workOrderNo, 226, 14);
                doc.text(dateCompleted === "" ? todaysDate : dateCompleted, 226, 27.125);

                pageCount++;
                workingPage++;
              }     
              if(pageCount < 2){
                doc.text(line, letterPage.axisPointOne+2, 93+(doc.getFontSize()/1.4*index));
              }else{
                doc.text(line, letterPage.axisPointOne+10-90, 48+(doc.getFontSize()/1.4*(index-(8*(pageCount-1)))));
              }
              
            });

            workingPage = 1;
            doc.setPage(workingPage); // reset to page one

            letterPage.stringToProcess(units[units.length-1]?.["Service Recommended"]).forEach((line, index)=>{
              if (index !== 0 && index % 3 === 0) { // Create a new page for every 3 lines
                if(workingPage < pageCount){
                  workingPage++;
                  doc.setPage(workingPage);
                }else{
                  doc.addPage("letter", "l");
                  doc.setFontSize(8);
                  doc.setTextColor(0,0,0);
                  doc.setDrawColor(0,0,0);
                  letterPage.drawOutline();
                  letterPage.drawTitleGrid(90);
                  letterPage.drawHorizontalUnitGrid(90, 45);
                  letterPage.drawUnitDescriptionGrid(90, 45);
                  
                  doc.setFontSize(9);
                  doc.setTextColor(0,0,255);
                  doc.setDrawColor(0,0,255);
    
                  if(units?.length > 0){
                    doc.text(units[units.length-1]?.Make, letterPage.axisPointOne+10-90, 38+(doc.getFontSize()/1.25*6)-45);
                    doc.text(units[units.length-1]?.Model, letterPage.axisPointOne+67-90, 38+(doc.getFontSize()/1.25*6)-45);
                    doc.text(`${units[units.length-1]?.Serial}  -> CONTINUED...`, letterPage.axisPointOne+125-90, 38+(doc.getFontSize()/1.25*6)-45);
                  }

                  doc.text(workOrderNo, 226, 14);
                  doc.text(dateCompleted === "" ? todaysDate : dateCompleted, 226, 27.125);
    
                  pageCount++;
                  workingPage++;
                }
              }     
              if(workingPage < 2){
                doc.text(line, letterPage.axisPointOne+2, 151+(doc.getFontSize()/1.4*index));
              }else{
                doc.text(line, letterPage.axisPointOne+10-90, 106+(doc.getFontSize()/1.4*(index-(3*(workingPage-1)))));
              }
              
            });
            
            doc.setTextColor(0,0,0);
            doc.setDrawColor(0,0,0);
          },
          drawMultiUnits: ()=>{
            if(units?.length > 1){
              for(let x=units.length-2; x>=0; --x){
                const originalPageCount = doc.internal.getNumberOfPages();
                let pageCount = doc.internal.getNumberOfPages();
                let workingPage = pageCount;
                let unitPageCount = 1;
  
                doc.addPage("letter", "l");
                doc.setFontSize(8);
                letterPage.drawOutline();
                letterPage.drawTitleGrid(90);
                letterPage.drawHorizontalUnitGrid(90, 45);
                letterPage.drawUnitDescriptionGrid(90, 45);
                
                doc.setFontSize(9);
                doc.setTextColor(0,0,255);
                doc.setDrawColor(0,0,255);
                
                doc.text(units[x]?.Make, letterPage.axisPointOne+10-90, 38+(doc.getFontSize()/1.25*6)-45);
                doc.text(units[x]?.Model, letterPage.axisPointOne+67-90, 38+(doc.getFontSize()/1.25*6)-45);
                doc.text(units[x]?.Serial, letterPage.axisPointOne+125-90, 38+(doc.getFontSize()/1.25*6)-45);
  
                letterPage.stringToProcess(units[x]?.["Description of Work Performed"]).forEach((line, index)=>{
                  if (index !== 0 && index % 8 === 0) { // Create a new page for every 8 lines
  
                    pageCount++;
                    workingPage++;
                    unitPageCount++;
  
                    doc.addPage("letter", "l");
                    doc.setFontSize(8);
                    doc.setTextColor(0,0,0);
                    doc.setDrawColor(0,0,0);
                    letterPage.drawOutline();
                    letterPage.drawTitleGrid(90);
                    letterPage.drawHorizontalUnitGrid(90, 45);
                    letterPage.drawUnitDescriptionGrid(90, 45);
                    
                    doc.setFontSize(9);
                    doc.setTextColor(0,0,255);
                    doc.setDrawColor(0,0,255);
      
                    if(units?.length > 0){
                      doc.text(units[x]?.Make, letterPage.axisPointOne+10-90, 38+(doc.getFontSize()/1.25*6)-45);
                      doc.text(units[x]?.Model, letterPage.axisPointOne+67-90, 38+(doc.getFontSize()/1.25*6)-45);
                      if(pageCount > originalPageCount){
                        doc.text(`${units[x]?.Serial}  -> CONTINUED...`, letterPage.axisPointOne+125-90, 38+(doc.getFontSize()/1.25*6)-45);
                      }else{
                        doc.text(units[x]?.Serial, letterPage.axisPointOne+125-90, 38+(doc.getFontSize()/1.25*6)-45);
                      }
                    }
      
                    doc.text(workOrderNo, 226, 14);
                    doc.text(dateCompleted === "" ? todaysDate : dateCompleted, 226, 27.125);
                  }     
                  if(pageCount < originalPageCount+1){
                    doc.text(line, letterPage.axisPointOne+10-90, 48+(doc.getFontSize()/1.4*index));
                  }else{
                    doc.text(line, letterPage.axisPointOne+10-90, 48+(doc.getFontSize()/1.4*(index-(8*(unitPageCount-1)))));
                  }
                });
  
                workingPage = originalPageCount+1;
                unitPageCount = 1;
                doc.setPage(workingPage);
                
                letterPage.stringToProcess(units[x]?.["Service Recommended"]).forEach((line, index)=>{
                  if (index !== 0 && index % 3 === 0) { // Create a new page for every 3 lines
                    if(workingPage <= pageCount){
                      workingPage++;
                      unitPageCount++;
                      doc.setPage(workingPage);
                    }else{
  
                      pageCount++;
                      workingPage++;
                      unitPageCount++;
  
                      doc.addPage("letter", "l");
                      doc.setFontSize(8);
                      doc.setTextColor(0,0,0);
                      doc.setDrawColor(0,0,0);
                      letterPage.drawOutline();
                      letterPage.drawTitleGrid(90);
                      letterPage.drawHorizontalUnitGrid(90, 45);
                      letterPage.drawUnitDescriptionGrid(90, 45);
                      
                      doc.setFontSize(9);
                      doc.setTextColor(0,0,255);
                      doc.setDrawColor(0,0,255);
        
                      if(units?.length > 0){
                        doc.text(units[x]?.Make, letterPage.axisPointOne+10-90, 38+(doc.getFontSize()/1.25*6)-45);
                        doc.text(units[x]?.Model, letterPage.axisPointOne+67-90, 38+(doc.getFontSize()/1.25*6)-45);
                        if(pageCount > originalPageCount){
                          doc.text(`${units[x]?.Serial}  -> CONTINUED...`, letterPage.axisPointOne+125-90, 38+(doc.getFontSize()/1.25*6)-45);
                        }else{
                          doc.text(units[x]?.Serial, letterPage.axisPointOne+125-90, 38+(doc.getFontSize()/1.25*6)-45);
                        }
                      }
      
                      doc.text(workOrderNo, 226, 14);
                      doc.text(dateCompleted === "" ? todaysDate : dateCompleted, 226, 27.125);
        
                    }
                  }
                  if(workingPage < originalPageCount+2){ 
                    doc.text(line, letterPage.axisPointOne+10-90, 106+(doc.getFontSize()/1.4*index));
                  }else{
                    doc.text(line, letterPage.axisPointOne+10-90, 106+(doc.getFontSize()/1.4*(index-(3*(unitPageCount-1)))));
                  }
                });
                
                doc.text(workOrderNo, 226, 14);
                doc.text(dateCompleted === "" ? todaysDate : dateCompleted, 226, 27.125);
                
                doc.setTextColor(0,0,0);
                doc.setDrawColor(0,0,0);
              }
            }
          },
          drawPageNumbers: ()=>{
            const pages = doc.internal.getNumberOfPages();
            for(let x=0; x<pages; ++x){
              doc.setPage(x+1);
              doc.text(`Page - ${x+1} of ${pages}`, letterPage.paperWidth-doc.getTextWidth(`Page - ${x+1} of ${pages}`)- letterPage.margin, letterPage.paperHeight-letterPage.margin+((letterPage.margin*1.5)/2)+1);
            }
          },
        };

        doc.setFontSize(8);
        letterPage.drawOutline(1);
        letterPage.drawMaterialGrid();
        letterPage.drawMaterialChargesGrid();
        letterPage.drawTechLabourGrid();
        letterPage.drawTitleGrid();
        letterPage.drawHorizontalMainGrid();
        letterPage.drawHorizontalUnitGrid();
        letterPage.drawServiceInfoGrid();
        letterPage.drawUnitDescriptionGrid();
        letterPage.drawSignatureGrid();
        
        letterPage.fillOutForm();
        letterPage.drawMultiUnits();
        letterPage.drawPageNumbers();
        window.open(doc.output('bloburl'), '_blank');
      }).catch((error)=>{
        setShowSpinner(false);
        toast.error(`Failed to load resources to print pdf: ${error.message}`);
      });
    };

/*
    const toggleOrderButtonStatus = (invoiceOverride = false)=>{
      if(updateOrderButtonStatus === 'edit' && invoiceOverride === false){
        setUpdateOrderButtonStatus('save');
      }
      if(updateOrderButtonStatus === 'save' || invoiceOverride){
        if(emailTooltip !== ''){
          toast.error(`Email is not a valid format.`);
          return null;
        }
        
        // run a transaction on specific request, each tech
        // first load specific request, and each tech if applicable (loading them first will protect against changes)
        // update request and each tech if applicable
        // pass out work_order object and update request state (props.request.data) - as shown above
        setShowSpinner(true);
        const requestRef = doc(db, "invoiced_work_orders", props.request.id);
        runTransaction(db, async (transaction)=>{
          const requestDoc = await transaction.get(requestRef);
          if(!requestDoc.exists()){
            throw new Error("Request document does not exist");
          }
        
          let updateHourDocs = [];
          let addHourDocs = [];
          let removeHourDocs = []
          // console.log(hours);
          for(let x=0; x<hours.length; ++x){
            const updateDocInfo = await transaction.get(doc(db, "hours", `${props.request.id}_${hours[x].techID}`));
            if(updateDocInfo.exists()){
              updateHourDocs.push(hours[x]);
            }else{
              addHourDocs.push(hours[x]);
            }
          }

          for(let x=0; x<props.currentworkorderhours.length; ++x){
            if(!hours.find(tech => {
                if(tech.techID === props.currentworkorderhours[x].techID){
                  return true; 
                }
                return false; // add to be deleted, cannot be found
              })){
                removeHourDocs.push(props.currentworkorderhours[x]);
            }
          }

          for(let x=0; x<updateHourDocs.length; ++x){
            await transaction.update(doc(db, "hours", `${updateHourDocs[x].requestID}_${updateHourDocs[x].techID}`), updateHourDocs[x]);
          }

          for(let x=0; x<addHourDocs.length; ++x){
            await transaction.set(doc(db, "hours", `${addHourDocs[x].requestID}_${addHourDocs[x].techID}`), addHourDocs[x]);
          }

          for(let x=0; x<removeHourDocs.length; ++x){
            await transaction.delete(doc(db, "hours", `${removeHourDocs[x].requestID}_${removeHourDocs[x].techID}`));
          }
          const newHoursState = hours;
          const newState = {...requestDoc.data(),
            work_order: {
              cust_auth_contact: custName,
              service_at: serviceAt,
              phone_number: custPhoneNo,
              email_address: custEmail,
              request_type: requestType,
              type_of_service: typeOfService,
              details: requestDetails,
              order_number: workOrderNo,
              customer: customer,
              customer_purchase_order: customerPurchaseOrder,
              scheduled_date: HTMLDateInputToTimestamp(scheduledDate),
              priority: parseInt(scheduledPriority),
              lead_tech: leadTech,
              assigned_techs: assignedTechnicians,
              units: units,
              materials: materials,
              // hours: hours,
              truck_charge: parseFloat(truckCharge),
              last_saved: {by: currentUser.email, at: currentTimeStamp()},
              quote_number: quoteNo,
              quote_amount: quoteAmount,
              invoice_number: invoiceNumber,
            }
          };
          // newState.status = updatedStatus;
          await transaction.update(requestRef, newState);

          return {newState: newState, newHoursState: newHoursState};
        }).then((states)=>{
          // update state of props.request.data
          // set props
          props.request.data = {...props.request.data, 
            work_order: {
              cust_auth_contact: custName,
              service_at: serviceAt,
              phone_number: custPhoneNo,
              email_address: custEmail,
              request_type: requestType,
              type_of_service: typeOfService,
              details: requestDetails,
              order_number: workOrderNo,
              customer: customer,
              customer_purchase_order: customerPurchaseOrder,
              scheduled_date: HTMLDateInputToTimestamp(scheduledDate),
              priority: parseInt(scheduledPriority),
              lead_tech: leadTech,
              assigned_techs: assignedTechnicians,
              units: units,
              materials: materials,
              // hours: hours,
              truck_charge: parseFloat(truckCharge),
              last_saved: {by: currentUser.email, at: currentTimeStamp()},
              quote_number: quoteNo,
              quote_amount: quoteAmount,
              invoice_number: invoiceNumber,
            }
          };
          // props.request.data.status = updatedStatus;

          // props.setcurrentworkorderhours(states.newHoursState);
          setHours(states.newHoursState);
        }).then(()=>{
          setShowSpinner(false);
          setUpdateOrderButtonStatus('edit');
          setDisplayPrintOptions(false);
          toast.success(`Successfully updated work order: ${workOrderNo}`);
          // props.onHide('no cancel', updateOrderButtonStatus);
        }).catch((error)=>{
          setShowSpinner(false);
          toast.error(`Failed to save data: ${error.message}`);
        });
      }
    };
*/
    const updateAssignedTechnicians = (event)=>{
      // console.log(event.target.selectedOptions)
      setAssignedTechnicians([].slice.call(event.target.selectedOptions).map(item => item.value));
      if(event.target.selectedOptions.length === 0){
        setLeadTech('');
        return null;
      }
      if(event.target.selectedOptions.length === 1){
        setLeadTech(event.target.selectedOptions[0].value);
        return null;
      }
      if(![].slice.call(event.target.selectedOptions).find(tech => tech.value === leadTech)){
        setLeadTech([].slice.call(event.target.selectedOptions)[0].value);
        return null;
      }
    };
    const addUnits = () => {
      const COOLING_DESCRIPTION = `- INSPECTED COILS, CLEANED P-TRAPS\n- CHECKED REFRIDGERANT LEVELS\n- INSPECTED & CHANGED DIRTY FILTERS\n- REPLACED, ADJUSTED BELTS AS NECESSARY\n- CHECKED COOLING OPERATION, ELECTRICAL & MECHANICAL ALSO\n- INSPECTED & LUBRICATED MECHANICAL COMPONENTS AS NECESSARY`;
      const COOLING_RECOMMENDED = `FOR INDIVIDUAL UNIT FINDINGS, PLEASE REFER TO PM FIELD REPORT`;

      const HEATING_DESCRIPTION = `- INSPECTED HEAT EXCHANGERS\n- CHECKED HEATING OPERATION, ELECTRICAL & MECHANICAL\n- CHANGED SOILED AIR FILTERS\n- CHANGED, ADJUSTED BELTS AS NECESSARY\n- LUBRICATED MECHANICAL COMPONENTS AS REQUIRED\n- CHECKED HIGH LIMIT & ROLLOUT SAFETIES\n- CHECKED ALL ELECTRICAL CONNECTIONS, WIRING & SAFETIES`;
      const HEATING_RECOMMENDED = `FOR INDIVIDUAL UNIT FINDINGS, PLEASE REFER TO PM FIELD REPORT`;

      let desc_of_work_performed_string = '';
      let service_recommended_string = '';
      if(typeOfService === 'Cooling'){
        desc_of_work_performed_string = COOLING_DESCRIPTION;
        service_recommended_string = COOLING_RECOMMENDED;
      }
      if(typeOfService === 'Heating'){
        desc_of_work_performed_string = HEATING_DESCRIPTION;
        service_recommended_string = HEATING_RECOMMENDED;
      }

      let tempUnits = [...units];
      tempUnits.unshift({
        Make: '',
        Model: '',
        Serial: '',
        'Description of Work Performed': desc_of_work_performed_string,
        'Service Recommended': service_recommended_string,
      });
      setUnits(tempUnits);
    };
    const removeUnits = (index) => {
      let tempUnits = [...units];
      tempUnits.splice(index, 1);
      setUnits(tempUnits);
    };
  
    const updateUnits = (unit, field, value)=>{
      let tempUnits = [...units];
      let tempUnit = {
        ...tempUnits[unit],
        [field]: value,
      };
      tempUnits[unit] = tempUnit;
      setUnits(tempUnits);
    };
    const addMaterials = () => {
      let tempMaterials = [...materials];
      tempMaterials.unshift({Source: '', Qty: '', 'Material Description': '', 'Price': ''});
      setMaterials(tempMaterials);
    };
    const removeMaterials = (index) => {
      let tempMaterials = [...materials];
      tempMaterials.splice(index, 1);
      setMaterials(tempMaterials);
    };
    const updateMaterials = (material, field, value)=>{
      let tempMaterials = [...materials];
      let tempMaterial = {
        ...tempMaterials[material],
        [field]: value,
      };
      tempMaterials[material] = tempMaterial;
      setMaterials(tempMaterials);
    };

    const addHours = ()=>{
      // later update setCurrentWorkOrderHours on the maint screen after saving
      console.log(hours)
      let tempHours = [...hours];
      tempHours.push({
        Monday: "",
        Tuesday: "",
        Wednesday: "",
        Thursday: "",
        Friday: "",
        Saturday: "",
        Sunday: "",
        Premium_Monday: "",
        Premium_Tuesday: "",
        Premium_Wednesday: "",
        Premium_Thursday: "",
        Premium_Friday: "",
        Premium_Saturday: "",
        Premium_Sunday: "",
        'Premium Monday Rate': "",
        'Premium Tuesday Rate': "",
        'Premium Wednesday Rate': "",
        'Premium Thursday Rate': "",
        'Premium Friday Rate': "",
        'Premium Saturday Rate': "",
        'Premium Sunday Rate': "",
        'Monday Rate': "",
        'Tuesday Rate': "",
        'Wednesday Rate': "",
        'Thursday Rate': "",
        'Friday Rate': "",
        'Saturday Rate': "",
        'Sunday Rate': "",
        order_number: workOrderNo,
        requestID: props.request.id,
        techID: techToAddHours,
        last_saved: {
          at: currentTimeStamp(),
          by: currentUser.email,
        },
      });
      // console.log(tempHours);
      setHours(tempHours);
    };
    const removeHours = (index)=>{
      let tempHours = [...hours];
      tempHours.splice(index, 1);
      setHours(tempHours);
    };
    const updateTechHours = (index, field, value)=> {
      let tempHours = [...hours];
      tempHours[index] = {...hours[index],
        [field]: value,
      };
      setHours(tempHours);
    };
    const loadCustomerRateHours = (index)=>{
      // if location hourly rate is valid
      if((props?.currentclientinfo?.location_info[0]?.["Hourly Rate"] !== "") && (props?.currentclientinfo?.location_info[0]?.["Hourly Rate"] !== undefined ) && (props?.currentclientinfo?.location_info[0]?.["Hourly Rate"] !== null)){
        let tempHours = [...hours];
        // if location hourly rate and location premium hours valid
        if(props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"] !== "" && props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"] !== undefined && props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"] !== null){
          tempHours[index] = {...hours[index],
            'Monday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Tuesday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Wednesday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Thursday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Friday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Saturday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Sunday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Premium Monday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Tuesday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Wednesday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Thursday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Friday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Saturday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Sunday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
          };
          setHours(tempHours);
          // if location hourly rate and customer premium hours valid
        } else if(props?.currentclientinfo?.client_info?.["Premium Hours"] !== "" && props?.currentclientinfo?.client_info?.["Premium Hours"] !== undefined && props?.currentclientinfo?.client_info?.["Premium Hours"] !== null){
          tempHours[index] = {...hours[index],
            'Monday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Tuesday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Wednesday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Thursday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Friday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Saturday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Sunday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Premium Monday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
            'Premium Tuesday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
            'Premium Wednesday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
            'Premium Thursday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
            'Premium Friday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
            'Premium Saturday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
            'Premium Sunday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
          };
          setHours(tempHours);
          // if location hourly rate valid, but no premium hours valid
        } else {
          tempHours[index] = {...hours[index],
            'Monday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Tuesday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Wednesday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Thursday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Friday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Saturday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Sunday Rate': props?.currentclientinfo?.location_info[0]?.["Hourly Rate"],
            'Premium Monday Rate': "",
            'Premium Tuesday Rate': "",
            'Premium Wednesday Rate': "",
            'Premium Thursday Rate': "",
            'Premium Friday Rate': "",
            'Premium Saturday Rate': "",
            'Premium Sunday Rate': "",
          };
          setHours(tempHours);
        }
        // if customer hourly rate valid
      } else if((props?.currentclientinfo?.client_info?.["Hourly Rate"] !== "") && (props?.currentclientinfo?.client_info?.["Hourly Rate"] !== undefined)  && (props?.currentclientinfo?.client_info?.["Hourly Rate"] !== null)){
        let tempHours = [...hours];
        // if customer houlry rate valid and location premium hours valid
        if(props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"] !== "" && props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"] !== undefined && props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"] !== null){
          tempHours[index] = {...hours[index],
            'Monday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Tuesday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Wednesday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Thursday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Friday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Saturday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Sunday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Premium Monday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Tuesday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Wednesday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Thursday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Friday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Saturday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Sunday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
          };
          setHours(tempHours);
          // if customer houlry rate valid and customer premium hours valid
        } else if(props?.currentclientinfo?.client_info?.["Premium Hours"] !== "" && props?.currentclientinfo?.client_info?.["Premium Hours"] !== undefined && props?.currentclientinfo?.client_info?.["Premium Hours"] !== null){
          tempHours[index] = {...hours[index],
            'Monday Rate': props?.props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Tuesday Rate': props?.props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Wednesday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Thursday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Friday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Saturday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Sunday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Premium Monday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
            'Premium Tuesday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
            'Premium Wednesday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
            'Premium Thursday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
            'Premium Friday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
            'Premium Saturday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
            'Premium Sunday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
          };
          setHours(tempHours);
          // if customer houlry rate valid but no premium hours valid
        } else{
          tempHours[index] = {...hours[index],
            'Monday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Tuesday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Wednesday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Thursday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Friday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Saturday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Sunday Rate': props?.currentclientinfo?.client_info?.["Hourly Rate"],
            'Premium Monday Rate': "",
            'Premium Tuesday Rate': "",
            'Premium Wednesday Rate': "",
            'Premium Thursday Rate': "",
            'Premium Friday Rate': "",
            'Premium Saturday Rate': "",
            'Premium Sunday Rate': "",
          };
          setHours(tempHours)
        }
        // if no location or customer hours are valid
      } else {
        let tempHours = [...hours];
        // if location premium hours are valid
        if(props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"] !== "" && props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"] !== undefined && props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"] !== null){
          tempHours[index] = {...hours[index],
            'Monday Rate': "",
            'Tuesday Rate': "",
            'Wednesday Rate': "",
            'Thursday Rate': "",
            'Friday Rate': "",
            'Saturday Rate': "",
            'Sunday Rate': "",
            'Premium Monday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Tuesday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Wednesday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Thursday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Friday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Saturday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
            'Premium Sunday Rate': props?.currentclientinfo?.location_info[0]?.["Premium Hours Rate"],
          };
          setHours(tempHours);
        // if customer premium hours are valid
        } else if(props?.currentclientinfo?.client_info?.["Premium Hours"] !== "" && props?.currentclientinfo?.client_info?.["Premium Hours"] !== undefined && props?.currentclientinfo?.client_info?.["Premium Hours"] !== null){
          tempHours[index] = {...hours[index],
            'Monday Rate': "",
            'Tuesday Rate': "",
            'Wednesday Rate': "",
            'Thursday Rate': "",
            'Friday Rate': "",
            'Saturday Rate': "",
            'Sunday Rate': "",
            'Premium Monday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
            'Premium Tuesday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
            'Premium Wednesday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
            'Premium Thursday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
            'Premium Friday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
            'Premium Saturday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
            'Premium Sunday Rate': props?.currentclientinfo?.client_info?.["Premium Hours"],
          };
          setHours(tempHours);
        // if no hours are valid
        } else {
          tempHours[index] = {...hours[index],
            'Monday Rate': "",
            'Tuesday Rate': "",
            'Wednesday Rate': "",
            'Thursday Rate': "",
            'Friday Rate': "",
            'Saturday Rate': "",
            'Sunday Rate': "",
            'Premium Monday Rate': "",
            'Premium Tuesday Rate': "",
            'Premium Wednesday Rate': "",
            'Premium Thursday Rate': "",
            'Premium Friday Rate': "",
            'Premium Saturday Rate': "",
            'Premium Sunday Rate': "",
          };
          setHours(tempHours);
        }
      }
    };
    const updateTechRateHours = (index, defaultHoursObject)=>{
      let tempHours = [...hours];
      tempHours[index] = {...hours[index],
        'Monday Rate': defaultHoursObject?.Monday,
        'Tuesday Rate': defaultHoursObject?.Tuesday,
        'Wednesday Rate': defaultHoursObject?.Wednesday,
        'Thursday Rate': defaultHoursObject?.Thursday,
        'Friday Rate': defaultHoursObject?.Friday,
        'Saturday Rate': defaultHoursObject?.Saturday,
        'Sunday Rate': defaultHoursObject?.Sunday,
      };
      setHours(tempHours);
    };

    const getTotalHours = () =>{
      let totalLabour = 0.00;
      hours.forEach((tech, index)=>{
        if(assignedTechnicians.includes(tech.techID)){
          
          let monday = tech?.Monday !== undefined && tech?.Monday !== "" ? parseFloat(tech.Monday) : 0;
          let mondayPremium = tech?.Premium_Monday !== undefined && tech?.Premium_Monday !== "" ? parseFloat(tech.Premium_Monday) : 0;
          let tuesday = tech?.Tuesday !== undefined && tech?.Tuesday !== "" ? parseFloat(tech.Tuesday) : 0;
          let tuesdayPremium = tech?.Premium_Tuesday !== undefined && tech?.Premium_Tuesday !== "" ? parseFloat(tech.Premium_Tuesday) : 0;
          let wednesday = tech?.Wednesday !== undefined && tech?.Wednesday !== "" ? parseFloat(tech?.Wednesday) : 0;
          let wednesdayPremium = tech?.Premium_Wednesday !== undefined && tech?.Premium_Wednesday !== "" ? parseFloat(tech?.Premium_Wednesday) : 0;
          let thursday = tech?.Thursday !== undefined && tech?.Thursday !== "" ? parseFloat(tech?.Thursday) : 0;
          let thursdayPremium = tech?.Premium_Thursday !== undefined && tech?.Premium_Thursday !== "" ? parseFloat(tech?.Premium_Thursday) : 0;
          let friday = tech?.Friday !== undefined && tech?.Friday !== "" ? parseFloat(tech?.Friday) : 0;
          let fridayPremium = tech?.Premium_Friday !== undefined && tech?.Premium_Friday !== "" ? parseFloat(tech?.Premium_Friday) : 0;

          let saturday = tech?.Saturday !== undefined && tech?.Saturday !== "" ? parseFloat(tech?.Saturday) : 0;
          let sunday = tech?.Sunday !== undefined && tech?.Sunday !== "" ? parseFloat(tech?.Sunday) : 0;
          let saturdayPremium = tech?.Premium_Saturday !== undefined && tech?.Premium_Saturday !== "" ? parseFloat(tech?.Premium_Saturday) : 0;
          let sundayPremium = tech?.Premium_Sunday !== undefined && tech?.Premium_Sunday !== "" ? parseFloat(tech?.Premium_Sunday) : 0;
          
          let mondayRate = tech?.["Monday Rate"] !== undefined && tech?.["Monday Rate"] !== "" ? parseFloat(tech?.["Monday Rate"]) : 0;
          let tuesdayRate = tech?.["Tuesday Rate"] !== undefined && tech?.["Tuesday Rate"] !== "" ? parseFloat(tech?.["Tuesday Rate"]) : 0;
          let wednesdayRate = tech?.["Wednesday Rate"] !== undefined && tech?.["Wednesday Rate"] !== "" ? parseFloat(tech?.["Wednesday Rate"]) : 0;
          let thursdayRate = tech?.["Thursday Rate"] !== undefined && tech?.["Thursday Rate"] !== "" ? parseFloat(tech?.["Thursday Rate"]) : 0;
          let fridayRate = tech?.["Friday Rate"] !== undefined && tech?.["Friday Rate"] !== "" ? parseFloat(tech?.["Friday Rate"]) : 0;
          let saturdayRate = tech?.["Saturday Rate"] !== undefined && tech?.["Saturday Rate"] !== "" ? parseFloat(tech?.["Saturday Rate"]) : 0;
          let sundayRate = tech?.["Sunday Rate"] !== undefined && tech?.["Sunday Rate"] !== "" ? parseFloat(tech?.["Sunday Rate"]) : 0;

          let mondayPremiumRate = tech?.["Premium Monday Rate"] !== undefined && tech?.["Premium Monday Rate"] !== "" ? parseFloat(tech?.["Premium Monday Rate"]) : 0;
          let tuesdayPremiumRate = tech?.["Premium Tuesday Rate"] !== undefined && tech?.["Premium Tuesday Rate"] !== "" ? parseFloat(tech?.["Premium Tuesday Rate"]) : 0;
          let wednesdayPremiumRate = tech?.["Premium Wednesday Rate"] !== undefined && tech?.["Premium Wednesday Rate"] !== "" ? parseFloat(tech?.["Premium Wednesday Rate"]) : 0;
          let thursdayPremiumRate = tech?.["Premium Thursday Rate"] !== undefined && tech?.["Premium Thursday Rate"] !== "" ? parseFloat(tech?.["Premium Thursday Rate"]) : 0;
          let fridayPremiumRate = tech?.["Premium Friday Rate"] !== undefined && tech?.["Premium Friday Rate"] !== "" ? parseFloat(tech?.["Premium Friday Rate"]) : 0;
          let saturdayPremiumRate = tech?.["Premium Saturday Rate"] !== undefined && tech?.["Premium Saturday Rate"] !== "" ? parseFloat(tech?.["Premium Saturday Rate"]) : 0;
          let sundayPremiumRate = tech?.["Premium Sunday Rate"] !== undefined && tech?.["Premium Sunday Rate"] !== "" ? parseFloat(tech?.["Premium Sunday Rate"]) : 0;
          
          totalLabour += ((monday-mondayPremium) * mondayRate) + (mondayPremium * mondayPremiumRate);
          totalLabour += ((tuesday-tuesdayPremium) * tuesdayRate) + (tuesdayPremium * tuesdayPremiumRate);
          totalLabour += ((wednesday-wednesdayPremium) * wednesdayRate) + (wednesdayPremium * wednesdayPremiumRate);
          totalLabour += ((thursday-thursdayPremium) * thursdayRate) + (thursdayPremium * thursdayPremiumRate);
          totalLabour += ((friday-fridayPremium) * fridayRate) + (fridayPremium * fridayPremiumRate);
          totalLabour += ((saturday-saturdayPremium) * saturdayRate) + (saturdayPremium * saturdayPremiumRate);
          totalLabour += ((sunday-sundayPremium) * sundayRate) + (sundayPremium * sundayPremiumRate);
        }
      })
      // end tech labour
      // labour charges
       return Math.round(totalLabour*100)/100;
    };
    const getTotalMaterialCost = ()=>{
      let materialTotalCost = 0.00;
      for (let item=materials.length-1; item>=0; --item){
        // materials.forEach((item, index)=>{
        let cost = parseFloat(materials[item].Price);
        if(materials[item]?.Price === undefined){materials[item].Price = "" };
        if(materials[item].Price === ""){ cost = 0 };
        
        materialTotalCost += cost;
         
        let dollars = materials[item].Price.split('.')[0] !== undefined ? materials[item].Price.split('.')[0].toString() : "0";
        if(dollars.length === 0){ dollars = "0" };
        
        let cents = materials[item].Price.split('.')[1] !== undefined ? materials[item].Price.split('.')[1].toString() : "00";
        if(cents.length === 1){ cents = `${cents}0` };
      }
      return materialTotalCost;
    }

    return(
      <Modal
        {...props}
        size="xl"
        // fullscreen
        animation={false}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>{props?.request?.data?.type.toUpperCase()}: {props?.request?.data?.work_order?.service_at === undefined ? props?.request?.data?.address : props?.request.data.work_order.service_at} - {props?.request?.data?.work_order?.order_number === undefined ? props?.request?.data?.["client name"] : props?.request?.data?.work_order?.order_number === '' ? props?.request?.data?.["client name"] : props?.request?.data?.work_order?.order_number}</Modal.Title>
          <div onClick={()=>{
            setUpdateOrderButtonStatus('edit');
            setDisplayPrintOptions(false);
            props.onHide('show cancel', updateOrderButtonStatus)
            }}>
                <CustomCloseButton />
            </div>
        </Modal.Header>
        <Modal.Body>
          <Container fluid style={{marginTop:"20px"}}>
            <Row>
              <Col lg="6" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                <Row style={{marginBottom: "20px"}}><Col>GENERAL INFORMATION</Col></Row>
                <Row style={{marginLeft: "20px", marginTop:"10px"}}>
                    <Col>
                        Status: 
                        {props?.request?.data?.status === 1 && ' NEW REQUEST'}
                        {props?.request?.data?.status === 2 && ' CREATED WORK ORDER'}
                        {props?.request?.data?.status === 3 && ' SCHEDULED WORK ORDER'}
                        {props?.request?.data?.status === 4 && ' COMPLETED WORK ORDER'}
                        {props?.request?.data?.status === 5 && ' FINALIZED WORK ORDER'}
                        {props?.request?.data?.status === 6 && ' INVOICED WORK ORDER'}
                    </Col>
                </Row>
                {/*<Row style={{marginLeft: "20px", marginTop:"10px", width:"400px"}}><Col>Service At:</Col><Col><a href={`https://www.google.com/maps/place/${serviceAt}`} target="_blank" rel="noreferrer">View Map</a></Col></Row>*/}
              </Col>
              <Col lg="6" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                <Row style={{marginBottom: "20px"}}><Col>ACTION BUTTONS</Col></Row>
                <Row>
                {/*
                  <Col lg="4">
                    <Button
                      className="btn-dark"
                      style={{backgroundColor:"#2596be", margin:5}}
                      onClick={()=>{
                        toggleOrderButtonStatus();
                      }}
                      >
                    {updateOrderButtonStatus === 'edit' ? "Edit Work Order" : "Save Work Order" }
                    </Button>
                  </Col>
                */}
                  <Col lg="4">
                    {
                      updateOrderButtonStatus === 'save' ?
                        <Button
                          className="btn-dark"
                          style={{backgroundColor:"#2596be", margin:5}}
                          onClick={()=>{
                            setUpdateOrderButtonStatus('edit');
                            setDisplayPrintOptions(false);
                            props.onHide('show cancel', updateOrderButtonStatus);
                          }}
                        >
                          Cancel
                        </Button>
                      :
                          <div></div>
                  }
                  </Col>
                  <Col lg="4">
                    <Button 
                      className="btn-dark"
                      style={{backgroundColor:"#2596be"}}
                      onClick={()=>{
                        setDisplayPrintOptions(!displayPrintOptions);
                      }}
                    >
                      Print Options
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
            {
              displayPrintOptions &&
              <Row className="justify-content-center">
                <Col lg="6" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                  <Row style={{marginLeft:"5px"}}>PRINT OPTIONS</Row>
                  <Row style={{marginLeft:"15px"}}>
                    <Form.Check
                      type="checkbox"
                      id="invoice-number"
                      label="Invoice Number"
                      checked={printInvoiceNumber}
                      onChange={()=>{
                        setPrintInvoiceNumber(!printInvoiceNumber);
                      }}
                      disabled={true}
                    />
                  </Row>
                  <Row style={{marginLeft:"15px"}}>
                    <Form.Check
                      type="checkbox"
                      id="Quote-number"
                      label={`Quote Number: ${quoteNo} AMT: $${quoteAmount}`}
                      checked={printQuoteNumber}
                      onChange={()=>{
                        setPrintQuoteNumber(!printQuoteNumber);
                      }}
                      disabled={true}
                    />
                  </Row>
                  <Row style={{marginLeft:"15px"}}>
                    <Form.Check
                      type="checkbox"
                      id="materials"
                      label="Materials"
                      checked={printMaterials}
                      onChange={()=>{
                        if(printMaterials === true){
                          setPrintMaterialCharges(false);
                        }else{
                          setPrintMaterialCharges(true);
                        }
                        setPrintMaterials(!printMaterials);
                      }}
                      disabled={true}
                    />
                  </Row>
                  {
                    printMaterials &&
                      <Row style={{marginLeft:"25px"}}>
                        <Form.Check
                          type="checkbox"
                          id="material-charges"
                          label="Material Charges"
                          checked={printMaterialCharges}
                          onChange={()=>{
                            setPrintMaterialCharges(!printMaterialCharges);
                          }}
                          disabled={true}
                        />
                    </Row>
                  }
                  <Row style={{marginLeft:"15px"}}>
                    <Form.Check
                      type="checkbox"
                      id="truck-charge"
                      label="Truck Charge"
                      checked={printTruckCharge}
                      onChange={()=>{
                        setPrintTruckCharge(!printTruckCharge);
                      }}
                      disabled={true}
                    />
                  </Row>
                  <Row style={{marginLeft:"15px"}}>
                    <Form.Check
                      type="checkbox"
                      id="hours"
                      label="Labour"
                      checked={printHours}
                      onChange={()=>{
                        setPrintHours(!printHours);
                      }}
                      disabled={true}
                    />
                  </Row>
                  <Row style={{marginLeft:"15px"}}>
                    Total on Invoice: ${
                      0 + 
                      (printQuoteNumber ? quoteAmount : 0) +
                      (printTruckCharge ? truckCharge : 0) +
                      (printHours ? getTotalHours() : 0) +
                      (printMaterialCharges ? getTotalMaterialCost() : 0)
                    }
                  </Row>
                  <Row style={{marginLeft:"15px", marginTop:"15px"}}>
                    <Col lg="4">
                      <Button 
                        className="btn-dark"
                        style={{backgroundColor:"#2596be"}}
                        onClick={()=>{
                          printWorkOrder()
                        }}
                      >
                        Print Work Order
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            }
            {
              updateOrderButtonStatus === 'edit' &&
                <Row>
                  <Col lg="12" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                    <Row className="text-center">
                      <div  style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
                        <div style={{marginRight:"5px"}}>Invoice #:</div>
                        <div style={{maxWidth:"400px"}}><Form.Control type="text" value={invoiceNumber} maxLength={inputMaxLengths.invoiceNumber} onChange={(e)=> setInvoiceNumber(e.target.value)} disabled={true}/></div>
                        {/*<Button
                          className="btn-dark"
                          style={{backgroundColor:"#2596be", margin:5}}
                          onClick={()=>{
                            if(invoiceNumber !== ""){
                              toggleOrderButtonStatus(true);
                              toast.warning("Saved invoice number to finalized work order, but not invoiced.");
                            }else{
                              toast.error("invoice number cannot be blank.");
                            }
                            
                          }}
                        >
                          SAVE
                        </Button>*/}
                        {/*
                        <Button
                          className="btn-dark"
                          style={{backgroundColor:"red", margin:5}}
                          onClick={()=>{
                            if(invoiceNumber !== ""){
                              if(displayPrintOptions){
                                if(window.confirm(
                                  `Print options will be saved as:\nInvoice Number: ${printInvoiceNumber}\nQuote Number: ${printQuoteNumber}\nShow Materials: ${printMaterials}\nPrint Material Charges: ${printMaterialCharges}\nPrint Truck Charge: ${printTruckCharge}\nPrint Hours & Charges: ${printHours}\nTotal Invoice: $${
                                    0 + 
                                    (printQuoteNumber ? quoteAmount : 0) +
                                    (printTruckCharge ? truckCharge : 0) +
                                    (printHours ? getTotalHours() : 0) +
                                    (printMaterialCharges ? getTotalMaterialCost() : 0)
                                  }\nWork Order will move to the invoiced folder.`
                                )){
                                  invoiced();
                                }else{
                                  toast.warning("Canceled: Not invoiced");
                                }
                              }else{
                                if(quoteNo === ""){
                                  setPrintQuoteNumber(false);
                                  setPrintTruckCharge(true);
                                  setPrintMaterials(true);
                                  setPrintMaterialCharges(true);
                                  setPrintHours(true);
                                }else{
                                  setPrintQuoteNumber(true);
                                  setPrintTruckCharge(false);
                                  setPrintMaterials(true);
                                  setPrintMaterialCharges(false);
                                  setPrintHours(false);
                                }
                                setDisplayPrintOptions(true)
                              } 
                            }else{
                              toast.error("invoice number cannot be blank.");
                            }
                            
                          }}
                        >
                          SAVE AND MARK INVOICED
                        </Button>
                        */}
                      </div>
                    </Row>
                  </Col>
                </Row>
            }
            <Row>
              <Col lg="6" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                <Row style={{marginBottom: "20px"}}><Col>REQUEST DETAILS</Col></Row>
                
                <Row style={{marginLeft:"10px"}}><Col>SERVICE AT:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={props?.request?.data?.address} disabled /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>CUST. PHONE No.</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={props?.request?.data?.['phone number']} disabled /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>CUST. AUTHORIZATION/CONTACT:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={props?.request?.data?.["client name"]} disabled /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>CUST. AUTHORIZATION/CONTACT EMAIL ADDRESS:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={props?.request?.data?.['email address']} disabled /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>REQUEST TYPE:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={props?.request?.data?.type} disabled /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>TYPE OF SERVICE:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={props?.request?.data?.type === 'quote' ? '' : props?.request?.data?.['type of service']} disabled /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>Details:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control as="textarea" value={props?.request?.data?.details} rows={4} disabled /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>REQUEST DATE: {timestampToHTMLDateInput(props?.request?.data?.timestamp)}</Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>ID: {props?.request?.id}</Col></Row>
              </Col>
              <Col lg="6" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                <Row style={{marginBottom: "20px"}}>
                  <Col>
                    {
                      props?.request?.data?.status === 1 ? "DISPATCH - CREATE WORK ORDER" : "WORK ORDER"
                    }
                  </Col>
                </Row>
                
                <Row style={{marginLeft:"10px"}}><Col>SERVICE AT:*</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={serviceAt} maxLength={inputMaxLengths.serviceAt} onChange={(e)=> setServiceAt(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>CUST. PHONE No.*</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={custPhoneNo} maxLength={inputMaxLengths.custPhoneNo} onChange={(e)=> setCustPhoneNo(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>CUST. AUTHORIZATION/CONTACT:*</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={custName} maxLength={inputMaxLengths.custAuthContact} onChange={(e)=> setCustName(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>CUST. AUTHORIZATION/CONTACT EMAIL ADDRESS:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                  <Col>
                    <Form.Control
                      type="text"
                      value={custEmail}
                      onChange={(e)=> {
                        if (emailReg.test(e.target.value) === false && e.target.value !== '') {
                          setEmailTooltip('Not a valid email format, must have an @ sign and a .');
                        } else {
                            setEmailTooltip('');
                        }
                        setCustEmail(e.target.value)
                      }}
                      required
                      disabled={updateOrderButtonStatus === 'edit' ? true : false}
                    />
                  </Col>
                </Row>
                <Row style={{color:'red', display:'flex', justifyContent:'center'}}>{emailTooltip}</Row>
                <Row style={{marginLeft:"10px"}}><Col>REQUEST TYPE:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                  {requestType === 'maintenance' && 
                    <Col>
                      <Form.Select as="select" value={requestType} onChange={(e)=> setRequestType(e.target.value)} required disabled={true} >
                        <option value={'maintenance'}>maintenance</option>
                      </Form.Select>
                    </Col>
                  }
                  {(requestType === 'service' || requestType === 'quote') && 
                    <Col>
                      <Form.Select as="select" value={requestType} onChange={(e)=> setRequestType(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} >
                        <option value={'service'}>service</option>
                        <option value={'quote'}>quote</option>
                      </Form.Select>
                    </Col>
                  }
                </Row>
                <Row style={{marginLeft:"10px"}}><Col>TYPE OF SERVICE:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                  {requestType === 'maintenance' && 
                    <Col>
                      <Form.Select as="select" value={typeOfService} onChange={(e)=> setTypeOfService(e.target.value)} required disabled={(updateOrderButtonStatus === 'edit' || requestType === 'quote') ? true : false} >
                        <option value={''}></option>
                        <option value={'Heating'}>Heating</option>
                        <option value={'Cooling'}>Cooling</option>
                        <option value={'Other (please provide details)'}>Other (please provide details)</option>
                      </Form.Select> 
                    </Col>
                  }
                  {(requestType === 'service' || requestType === 'quote') && 
                    <Col>
                      <Form.Select as="select" value={requestType === 'quote' ? '' : typeOfService} onChange={(e)=> setTypeOfService(e.target.value)} required disabled={(updateOrderButtonStatus === 'edit' || requestType === 'quote') ? true : false} >
                        <option value={''}></option>
                        <option value={'No Heat'}>No Heat</option>
                        <option value={'No AC'}>No AC</option>
                        <option value={'Other (please provide details)'}>Other (please provide details)</option>
                      </Form.Select> 
                    </Col>
                  }
                </Row>
                <Row style={{marginLeft:"10px"}}><Col>Details:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control as="textarea" value={requestDetails} maxLength={inputMaxLengths.details} onChange={(e)=>{setRequestDetails(e.target.value)}} rows={4} disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{display:'flex', justifyContent:'center'}}>{inputMaxLengths?.details - requestDetails?.length} characters remaining</Row>
                <Row style={{marginLeft:"10px"}}><Col>WORK ORDER No:*</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={workOrderNo} maxLength={inputMaxLengths.workorderNumber} onChange={(e)=> setWorkOrderNo(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>QUOTE:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={quoteNo} maxLength={inputMaxLengths.quoteNumber} onChange={(e)=> setQuoteNo(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>QUOTE AMT $:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="number" value={quoteAmount} maxLength={inputMaxLengths.quoteNumber} onChange={(e)=> {
                    if(e.target.value === ""){
                      setQuoteAmount('')
                    }else{
                      setQuoteAmount(parseFloat(e.target.value))
                    }
                  }}required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>CUSTOMER:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={customer} maxLength={inputMaxLengths.customer} onChange={(e)=> setCustomer(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{marginLeft:"10px"}}><Col>CUSTOMER PURCHASE ORDER:</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={customerPurchaseOrder} maxLength={inputMaxLengths.purchaseOrder} onChange={(e)=> setCustomerPurchaseOrder(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                
                <Row style={{marginLeft: "10px"}}><Col>DISPATCHED DATE: yyyy-mm-dd</Col></Row>
                <Row style={{marginLeft: "10px", maxWidth:"200px"}}><Col><Form.Control type="date" value={scheduledDate} onChange={(e)=> setScheduledDate(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{marginLeft: "10px", marginTop:"10px"}}><Col>PRIORITY:</Col></Row>
                <Row style={{marginLeft: "10px", maxWidth:"100px"}}><Col><Form.Control type="number" min="1" max="10" value={scheduledPriority} onChange={(e)=> setScheduledPriority(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                <Row style={{marginLeft:"10px", marginTop:"10px"}}><Col>ASSIGNED TECHNICIANS: {assignedTechnicians.length}</Col></Row>
                <Row style={{marginLeft:"20px", marginBottom:"10px", maxWidth:"300px"}}>
                  <Form.Control as="select" multiple value={assignedTechnicians} onChange={e => updateAssignedTechnicians(e)} disabled={updateOrderButtonStatus === 'edit' ? true : false} >
                      {
                        technicians.map((tech)=>{
                          return(
                            <option key={tech.id} value={tech.id}>{tech.data.tech_name}</option>
                          )
                        })
                      }
                  </Form.Control>
                </Row>
                <Row style={{marginLeft:"10px", marginTop:"10px"}}><Col>LEAD TECHNICIAN</Col></Row>
                <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}>
                  <Col>
                    <Form.Select as="select" value={leadTech} onChange={(e)=> setLeadTech(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} >
                      <option value={``}>{``}</option>
                      {
                        assignedTechnicians.map((tech)=>{
                          return(
                            technicians.find(searchTech=>searchTech.id === tech) !== undefined &&
                            <option
                              key={tech}
                              value={tech}
                            >
                              {
                                technicians.find(searchTech=>searchTech.id === tech).data.tech_name
                              }
                            </option>
                          )
                        })
                      }
                    </Form.Select>
                  </Col>
                </Row>
                <Row style={{marginLeft: "10px", marginTop:"10px"}}><Col>LAST UPDATED: {props?.request?.data?.work_order?.last_saved?.at !== undefined ? timestampToHTMLDateInput(props.request.data.work_order.last_saved.at) : ""}</Col></Row>
                <Row style={{marginLeft: "10px"}}><Col>BY: {props?.request?.data?.work_order?.last_saved?.by !== undefined ? props.request.data.work_order.last_saved.by : ""}</Col></Row>
              </Col>
            </Row>
            <Row>
              <Col lg="12" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                <Row style={{marginBottom: "20px"}}>
                  <Col>
                    WORK PERFORMED (Units: {units?.length})
                    {
                      updateOrderButtonStatus === 'save' ?
                        <Button
                          className="btn-dark"
                          style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                          onClick={()=>{
                            addUnits();
                          }}
                          >
                          <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCirclePlus} />
                        </Button>
                      :
                        ""
                    }
                  </Col>
                </Row>
                {
                  units.map((unit, index)=>{
                    return(
                      <Row key={index} style={{margin: 20}}>
                        <Row>
                          UNIT {index+1}
                          {
                            updateOrderButtonStatus === 'save' ?
                              <Button
                                className="btn-dark"
                                style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                                onClick={()=>{
                                  if(window.confirm(`Are you sure you want to delete UNIT ${index+1}`)){
                                    removeUnits(index);
                                  }
                                }}
                                >
                                <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCircleMinus} />
                              </Button>
                            :
                              ""
                          }
                        </Row>
                        <Row><Col>MAKE:</Col></Row>
                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={unit?.["Make"]} maxLength={inputMaxLengths.make} onChange={(e)=> updateUnits(index, 'Make', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                        <Row><Col>MODEL:</Col></Row>
                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={unit?.["Model"]} maxLength={inputMaxLengths.model} onChange={(e)=> updateUnits(index, 'Model', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                        <Row><Col>SERIAL:</Col></Row>
                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={unit?.["Serial"]} maxLength={inputMaxLengths.serial} onChange={(e)=> updateUnits(index, 'Serial', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                        <Row><Col>DESCRIPTION OF WORK PERFORMED:</Col></Row>
                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control as="textarea" value={unit?.["Description of Work Performed"]} onChange={(e)=> updateUnits(index, 'Description of Work Performed', e.target.value)} rows={8} disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                        <Row><Col>SERVICE RECOMMENDED:</Col></Row>
                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control as="textarea" value={unit?.["Service Recommended"]} onChange={(e)=> updateUnits(index, 'Service Recommended', e.target.value)} rows={3} disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                      </Row>
                    )
                  })
                }
              </Col>
            </Row>
            <Row>
              <Col lg="12" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                <Row style={{marginBottom: "20px"}}>
                  <Col>
                    MATERIALS (Entries: {materials?.length})
                    {
                      updateOrderButtonStatus === 'save' ?
                        <Button
                          className="btn-dark"
                          style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                          onClick={()=>{
                            addMaterials();
                          }}
                          >
                          <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCirclePlus} />
                        </Button>
                      :
                        ""
                    }
                  </Col>
                </Row>
                {
                  materials.map((material, index)=>{
                    return(
                      <Row key={index} style={{margin: 20}}>
                        <Row>
                          MATERIAL {index+1}
                          {
                            updateOrderButtonStatus === 'save' ?
                              <Button
                                className="btn-dark"
                                style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                                onClick={()=>{
                                  if(window.confirm(`Are you sure you want to delete MATERIAL ${index+1}`)){
                                    removeMaterials(index);
                                  }
                                }}
                                >
                                <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCircleMinus} />
                              </Button>
                            :
                              ""
                          }
                        </Row>
                        <Row><Col>SOURCE:</Col></Row>
                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={material?.["Source"]} maxLength={inputMaxLengths.source} onChange={(e)=> updateMaterials(index, 'Source', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                        <Row><Col>QTY:</Col></Row>
                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="number" min="0" value={material?.["Qty"]} maxLength={inputMaxLengths.qty} onChange={(e)=> updateMaterials(index, 'Qty', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                        <Row><Col>MATERIAL DESCRIPTION:</Col></Row>
                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="text" value={material?.["Material Description"]} maxLength={inputMaxLengths.materialDescription} onChange={(e)=> updateMaterials(index, 'Material Description', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                        <Row><Col>PRICE:</Col></Row>
                        <Row style={{marginLeft:"10px", marginRight:"10px", marginBottom:"10px"}}><Col><Form.Control type="number" min="0" value={material?.["Price"]} onChange={(e)=> updateMaterials(index, 'Price', e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} /></Col></Row>
                      </Row>
                    )
                  })
                }
              </Col>
            </Row>
            <Row>
              <Col lg="12" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                <Row style={{marginBottom: "20px"}}>
                  <Col>TRUCK CHARGE</Col>
                  <Col>{
                    updateOrderButtonStatus === 'save' ?
                      <Button
                        className="btn-dark"
                        style={{backgroundColor:"#2596be"}}
                        onClick={()=>{
                          setTruckCharge(props.defaulttruckcharge);
                          toast.info(`Truck Rate Field updated to ${props.defaulttruckcharge}, Save work order to confirm.`);
                        }}
                      >
                        Load Default Truck Charge
                      </Button>
                    :
                      ""
                  }</Col>
                </Row>
                <Form.Control style={{marginLeft:20, width:200}} type="number" min="0" value={truckCharge} onChange={(e)=> setTruckCharge(e.target.value)} required disabled={updateOrderButtonStatus === 'edit' ? true : false} />
              </Col>
            </Row>
            <Row>
              <Col lg="12" style={{border:"1px solid black", padding:"10px", borderRadius:"10px", marginBottom:"5px"}}>
                <Row style={{marginBottom: "20px"}}>
                  <Col>
                    HOURS (Techs: {hours.filter(tech => assignedTechnicians.includes(tech.techID)).length} of {assignedTechnicians.length})
                    {
                      updateOrderButtonStatus === 'save'  && assignedTechnicians.length > 0 && hours.filter(tech => assignedTechnicians.includes(tech.techID)).length < assignedTechnicians.length ?
                        <Button
                          className="btn-dark"
                          style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                          onClick={()=>{
                            if(techToAddHours !== "" && techToAddHours !== undefined){
                              addHours();
                            }else{
                              toast.warning('Please select a tech from the drop down');
                            }
                          }}
                          >
                          <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCirclePlus} />
                        </Button>
                      :
                        ""
                    }
                    </Col>
                    <Col>
                    {
                      updateOrderButtonStatus === 'save'  && assignedTechnicians.length > 0 && hours.filter(tech => assignedTechnicians.includes(tech.techID)).length < assignedTechnicians.length ?
                        <Form.Select as="select" style={{width:400}} value={techToAddHours} onChange={(e)=> setTechToAddHours(e.target.value) } >
                          <option value={``}>{``}</option>
                          {
                            assignedTechnicians.map((tech)=>{
                              return(
                                <option
                                  key={tech}
                                  value={tech}
                                >
                                  {
                                    hours.filter(e => e.techID === tech).length === 0 &&
                                      technicians.find(searchTech=>searchTech.id === tech).data.tech_name
                                  }
                                </option>
                              )
                            })
                          }
                        </Form.Select>
                      :
                        ""
                    }
                  </Col>
                </Row>
                {
                  hours.map((tech, index)=>{
                    return(
                      assignedTechnicians.includes(tech.techID) ?
                        <Row key={index} style={{marginTop: 20}}>
                          <Row style={{margin: 10}}>
                            <Col>
                              {index + 1}. {technicians.find(searchTech=>searchTech.id === tech.techID).data.tech_name}
                              {
                                updateOrderButtonStatus === 'save' ?
                                  <Button
                                    className="btn-dark"
                                    style={{backgroundColor:"#2596be", marginLeft:20, width:60}}
                                    onClick={()=>{
                                      if(window.confirm(`Are you sure you want to delete HOURS for ${technicians.find(searchTech=>searchTech.id === tech.techID).data.tech_name}`)){
                                        removeHours(index);
                                      }
                                    }}
                                    >
                                    <FontAwesomeIcon style={{fontSize: '1.75em'}} icon={faCircleMinus} />
                                  </Button>
                                :
                                  ""
                              }
                            </Col>
                            <Col>{
                              updateOrderButtonStatus === 'save' ?
                                <Button
                                  className="btn-dark"
                                  style={{backgroundColor:"#2596be"}}
                                  onClick={()=>{
                                    loadCustomerRateHours(index)
                                    toast.info(`Customer Rates for ${technicians.find(searchTech=>searchTech.id === tech.techID).data.tech_name} have been updated, Save work order to confirm.`);
                                  }}
                                >
                                  Use Customer Specific Rates
                                </Button>
                              :
                                ""
                            }
                            </Col>
                            <Col>{
                              updateOrderButtonStatus === 'save' ?
                                <Button
                                  className="btn-dark"
                                  style={{backgroundColor:"#2596be"}}
                                  onClick={()=>{
                                    updateTechRateHours(index, props.defaultdailyrates)
                                    toast.info(`Daily Rates for this ${technicians.find(searchTech=>searchTech.id === tech.techID).data.tech_name} have been updated, Save work order to confirm.`);
                                  }}
                                >
                                  Load Default Daily Rates
                                </Button>
                              :
                                ""
                            }
                            </Col>
                          </Row>
                          <Row style={{margin: 5}}>
                            <Col>
                              <Row style={{maxWidth:300}}>
                                <Col style={{textAlign:"right"}}>Mon:</Col>
                                <Col>
                                  <Form.Control
                                    style={{marginLeft:0,width:100}}
                                    type="number"
                                    min="0"
                                    onChange={(e)=>{
                                      updateTechHours(index, 'Monday', e.target.value)
                                    }}
                                    value={tech?.Monday}
                                    disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                  />
                                  </Col>
                                </Row>
                              </Col>
                            <Col>
                              <Row>
                                Rate: <Form.Control
                                  style={{marginLeft:20,width:100}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Monday Rate', e.target.value)
                                  }}
                                  value={tech?.["Monday Rate"]}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                />
                              </Row>
                            </Col>
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Hrs:
                                      <Form.Control
                                        style={{marginLeft:20,width:80}}
                                        type="number"
                                        min="0"
                                        onChange={(e)=>{
                                          updateTechHours(index, 'Premium_Monday', e.target.value)
                                        }}
                                        value={tech?.Premium_Monday === undefined ? 0 : tech.Premium_Monday}
                                        disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                      />
                                  </Row>
                                </Col>
                            }
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Rate: <Form.Control
                                      style={{marginLeft:20,width:80}}
                                      type="number"
                                      min="0"
                                      onChange={(e)=>{
                                        updateTechHours(index, 'Premium Monday Rate', e.target.value)
                                      }}
                                      value={tech?.["Premium Monday Rate"] === undefined ? 0 : tech["Premium Monday Rate"]}
                                      disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                    />
                                  </Row>
                                </Col>
                            }
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    {/** ((Total Hours-Premium Hours)*Rate) + (Premium Hours * Premium Rate) = Total */}
                                    $: {((parseFloat(tech?.Monday === "" || tech?.Monday === undefined ? 0 : tech.Monday) - parseFloat(tech?.Premium_Monday === "" || tech?.Premium_Monday === undefined ? 0 : tech.Premium_Monday)) * parseFloat(tech?.["Monday Rate"] === "" || tech?.["Monday Rate"] === undefined ? 0 : tech["Monday Rate"])) + (parseFloat(tech?.Premium_Monday === "" || tech?.Premium_Monday === undefined ? 0 : tech.Premium_Monday) * parseFloat(tech?.["Premium Monday Rate"] === "" || tech?.["Premium Monday Rate"] === undefined ? 0 : tech["Premium Monday Rate"]))}
                                  </Row>
                                </Col>
                            }
                          </Row>
                          <Row style={{margin: 5}}>
                            <Col>
                              <Row style={{maxWidth:300}}>
                                  <Col style={{textAlign:"right"}}>Tue:</Col>
                                  <Col>
                                    <Form.Control
                                      style={{marginLeft:0,width:100}}
                                      type="number"
                                      min="0"
                                      onChange={(e)=>{
                                        updateTechHours(index, 'Tuesday', e.target.value)
                                      }}
                                      value={tech?.Tuesday}
                                      disabled={updateOrderButtonStatus === 'edit' ? true : false} 
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            <Col>
                              <Row>Rate: <Form.Control
                                  style={{marginLeft:20,width:100}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Tuesday Rate', e.target.value)
                                  }}
                                  value={tech?.["Tuesday Rate"]}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false} 
                                />
                              </Row>
                            </Col>
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                      Premium Hrs:
                                        <Form.Control
                                          style={{marginLeft:20,width:80}}
                                          type="number"
                                          min="0"
                                          onChange={(e)=>{
                                            updateTechHours(index, 'Premium_Tuesday', e.target.value)
                                          }}
                                          value={tech?.Premium_Tuesday === undefined ? 0 : tech.Premium_Tuesday}
                                          disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                        />
                                  </Row>
                                </Col>
                            }
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                      Premium Rate: <Form.Control
                                        style={{marginLeft:20,width:80}}
                                        type="number"
                                        min="0"
                                        onChange={(e)=>{
                                          updateTechHours(index, 'Premium Tuesday Rate', e.target.value)
                                        }}
                                        value={tech?.["Premium Tuesday Rate"] === undefined ? 0 : tech["Premium Tuesday Rate"]}
                                        disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                      />
                                  </Row>
                                </Col>
                            }
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                  $: {((parseFloat(tech?.Tuesday === "" || tech?.Tuesday === undefined ? 0 : tech.Tuesday) - parseFloat(tech?.Premium_Tuesday === "" || tech?.Premium_Tuesday === undefined ? 0 : tech.Premium_Tuesday)) * parseFloat(tech?.["Tuesday Rate"] === "" || tech?.["Tuesday Rate"] === undefined ? 0 : tech["Tuesday Rate"])) + (parseFloat(tech?.Premium_Tuesday === "" || tech?.Premium_Tuesday === undefined ? 0 : tech.Premium_Tuesday) * parseFloat(tech?.["Premium Tuesday Rate"] === "" || tech?.["Premium Tuesday Rate"] === undefined ? 0 : tech["Premium Tuesday Rate"]))}
                                  </Row>
                                </Col>
                            }
                          </Row>
                          <Row style={{margin: 5}}>
                            <Col>
                              <Row style={{maxWidth:300}}>
                                <Col style={{textAlign:"right"}}>Wed:</Col>
                                <Col>
                                  <Form.Control
                                    style={{marginLeft:0,width:100}}
                                    type="number"
                                    min="0"
                                    onChange={(e)=>{
                                      updateTechHours(index, 'Wednesday', e.target.value)
                                    }}
                                    value={tech?.Wednesday}
                                    disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col>
                              <Row>Rate: <Form.Control
                                  style={{marginLeft:20,width:100}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Wednesday Rate', e.target.value)
                                  }} 
                                  value={tech?.["Wednesday Rate"]}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                />
                              </Row>
                            </Col>
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Hrs:
                                      <Form.Control
                                        style={{marginLeft:20,width:80}}
                                        type="number"
                                        min="0"
                                        onChange={(e)=>{
                                          updateTechHours(index, 'Premium_Wednesday', e.target.value)
                                        }}
                                        value={tech?.Premium_Wednesday === undefined ? 0 : tech.Premium_Wednesday}
                                        disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                      />
                                  </Row>
                                </Col>
                            }
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Rate: <Form.Control
                                      style={{marginLeft:20,width:80}}
                                      type="number"
                                      min="0"
                                      onChange={(e)=>{
                                        updateTechHours(index, 'Premium Wednesday Rate', e.target.value)
                                      }}
                                      value={tech?.["Premium Wednesday Rate"] === undefined ? 0 : tech["Premium Wednesday Rate"]}
                                      disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                    />
                                  </Row>
                                </Col>
                            }
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    $: {((parseFloat(tech?.Wednesday === "" || tech?.Wednesday === undefined ? 0 : tech.Wednesday) - parseFloat(tech?.Premium_Wednesday === "" || tech?.Premium_Wednesday === undefined ? 0 : tech.Premium_Wednesday)) * parseFloat(tech?.["Wednesday Rate"] === "" || tech?.["Wednesday Rate"] === undefined ? 0 : tech["Wednesday Rate"])) + (parseFloat(tech?.Premium_Wednesday === "" || tech?.Premium_Wednesday === undefined ? 0 : tech.Premium_Wednesday) * parseFloat(tech?.["Premium Wednesday Rate"] === "" || tech?.["Premium Wednesday Rate"] === undefined ? 0 : tech["Premium Wednesday Rate"]))}
                                  </Row>
                                </Col>
                            }
                          </Row>
                          <Row style={{margin: 5}}>
                            <Col>
                              <Row style={{maxWidth:300}}>
                                <Col style={{textAlign:"right"}}>Thu:</Col>
                                <Col>
                                  <Form.Control
                                    style={{marginLeft:0,width:100}}
                                    type="number"
                                    min="0"
                                    onChange={(e)=>{
                                      updateTechHours(index, 'Thursday', e.target.value)
                                    }}
                                    value={tech?.Thursday}
                                    disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col>
                              <Row>Rate: <Form.Control
                                  style={{marginLeft:20,width:100}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Thursday Rate', e.target.value)
                                  }}
                                  value={tech?.["Thursday Rate"]}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                />
                              </Row>
                            </Col>
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Hrs:
                                      <Form.Control
                                        style={{marginLeft:20,width:80}}
                                        type="number"
                                        min="0"
                                        onChange={(e)=>{
                                          updateTechHours(index, 'Premium_Thursday', e.target.value)
                                        }}
                                        value={tech?.Premium_Thursday === undefined ? 0 : tech.Premium_Thursday}
                                        disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                      />
                                  </Row>
                                </Col>
                            }
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Rate: <Form.Control
                                      style={{marginLeft:20,width:80}}
                                      type="number"
                                      min="0"
                                      onChange={(e)=>{
                                        updateTechHours(index, 'Premium Thursday Rate', e.target.value)
                                      }}
                                      value={tech?.["Premium Thursday Rate"] === undefined ? 0 : tech["Premium Thursday Rate"]}
                                      disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                    />
                                  </Row>
                                </Col>
                            }
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    $: {((parseFloat(tech?.Thursday === "" || tech?.Thursday === undefined ? 0 : tech.Thursday) - parseFloat(tech?.Premium_Thursday === "" || tech?.Premium_Thursday === undefined ? 0 : tech.Premium_Thursday)) * parseFloat(tech?.["Thursday Rate"] === "" || tech?.["Thursday Rate"] === undefined ? 0 : tech["Thursday Rate"])) + (parseFloat(tech?.Premium_Thursday === "" || tech?.Premium_Thursday === undefined ? 0 : tech.Premium_Thursday) * parseFloat(tech?.["Premium Thursday Rate"] === "" || tech?.["Premium Thursday Rate"] === undefined ? 0 : tech["Premium Thursday Rate"]))}
                                  </Row>
                                </Col>
                            }
                          </Row>
                          <Row style={{margin: 5}}>
                            <Col>
                              <Row style={{maxWidth:300}}>
                                <Col style={{textAlign:"right"}}>Fri:</Col>
                                <Col>
                                  <Form.Control
                                    style={{marginLeft:0,width:100}}
                                    type="number"
                                    min="0"
                                    onChange={(e)=>{
                                      updateTechHours(index, 'Friday', e.target.value)
                                    }}
                                    value={tech?.Friday}
                                    disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col>
                              <Row>Rate: <Form.Control
                                  style={{marginLeft:20,width:100}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Friday Rate', e.target.value)
                                  }}
                                  value={tech?.["Friday Rate"]}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                />
                              </Row>
                            </Col>
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Hrs:
                                      <Form.Control
                                        style={{marginLeft:20,width:80}}
                                        type="number"
                                        min="0"
                                        onChange={(e)=>{
                                          updateTechHours(index, 'Premium_Friday', e.target.value)
                                        }}
                                        value={tech?.Premium_Friday === undefined ? 0 : tech.Premium_Friday}
                                        disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                      />
                                  </Row>
                                </Col>
                            }
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Rate: <Form.Control
                                      style={{marginLeft:20,width:80}}
                                      type="number"
                                      min="0"
                                      onChange={(e)=>{
                                        updateTechHours(index, 'Premium Friday Rate', e.target.value)
                                      }}
                                      value={tech?.["Premium Friday Rate"] === undefined ? 0 : tech["Premium Friday Rate"]}
                                      disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                    />
                                  </Row>
                                </Col>
                            }
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    $: {((parseFloat(tech?.Friday === "" || tech?.Friday === undefined ? 0 : tech.Friday) - parseFloat(tech?.Premium_Friday === "" || tech?.Premium_Friday === undefined ? 0 : tech.Premium_Friday)) * parseFloat(tech?.["Friday Rate"] === "" || tech?.["Friday Rate"] === undefined ? 0 : tech["Friday Rate"])) + (parseFloat(tech?.Premium_Friday === "" || tech?.Premium_Friday === undefined ? 0 : tech.Premium_Friday) * parseFloat(tech?.["Premium Friday Rate"] === "" || tech?.["Premium Friday Rate"] === undefined ? 0 : tech["Premium Friday Rate"]))}
                                  </Row>
                                </Col>
                            }
                          </Row>
                          <Row style={{margin: 5}}>
                            <Col>
                              <Row style={{maxWidth:300}}>
                                <Col style={{textAlign:"right"}}>Sat:</Col>
                                <Col>
                                  <Form.Control
                                    style={{marginLeft:0,width:100}}
                                    type="number"
                                    min="0"
                                    onChange={(e)=>{
                                      updateTechHours(index, 'Saturday', e.target.value)
                                    }}
                                    value={tech?.Saturday}
                                    disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col>
                              <Row>Rate: <Form.Control
                                  style={{marginLeft:20,width:100}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Saturday Rate', e.target.value)
                                  }}
                                  value={tech?.["Saturday Rate"]}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                />
                              </Row>
                            </Col>
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Hrs:
                                      <Form.Control
                                        style={{marginLeft:20,width:80}}
                                        type="number"
                                        min="0"
                                        onChange={(e)=>{
                                          updateTechHours(index, 'Premium_Saturday', e.target.value)
                                        }}
                                        value={tech?.Premium_Saturday === undefined ? 0 : tech.Premium_Saturday}
                                        disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                      />
                                  </Row>
                                </Col>
                            }
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Rate: <Form.Control
                                      style={{marginLeft:20,width:80}}
                                      type="number"
                                      min="0"
                                      onChange={(e)=>{
                                        updateTechHours(index, 'Premium Saturday Rate', e.target.value)
                                      }}
                                      value={tech?.["Premium Saturday Rate"] === undefined ? 0 : tech["Premium Saturday Rate"]}
                                      disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                    />
                                  </Row>
                                </Col>
                            }
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    $: {((parseFloat(tech?.Saturday === "" || tech?.Saturday === undefined ? 0 : tech.Saturday) - parseFloat(tech?.Premium_Saturday === "" || tech?.Premium_Saturday === undefined ? 0 : tech.Premium_Saturday)) * parseFloat(tech?.["Saturday Rate"] === "" || tech?.["Saturday Rate"] === undefined ? 0 : tech["Saturday Rate"])) + (parseFloat(tech?.Premium_Saturday === "" || tech?.Premium_Saturday === undefined ? 0 : tech.Premium_Saturday) * parseFloat(tech?.["Premium Saturday Rate"] === "" || tech?.["Premium Saturday Rate"] === undefined ? 0 : tech["Premium Saturday Rate"]))}
                                  </Row>
                                </Col>
                            }
                          </Row>
                          <Row style={{margin: 5}}>
                            <Col>
                              <Row style={{maxWidth:300}}>
                                <Col style={{textAlign:"right"}}>Sun:</Col>
                                <Col>
                                  <Form.Control
                                    style={{marginLeft:0,width:100}}
                                    type="number"
                                    min="0"
                                    onChange={(e)=>{
                                      updateTechHours(index, 'Sunday', e.target.value)
                                    }}
                                    value={tech?.Sunday}
                                    disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col>
                              <Row>Rate: <Form.Control
                                  style={{marginLeft:20,width:100}}
                                  type="number"
                                  min="0"
                                  onChange={(e)=>{
                                    updateTechHours(index, 'Sunday Rate', e.target.value)
                                  }}
                                  value={tech?.["Sunday Rate"]}
                                  disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                />
                              </Row>
                            </Col>
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Hrs:
                                      <Form.Control
                                        style={{marginLeft:20,width:80}}
                                        type="number"
                                        min="0"
                                        onChange={(e)=>{
                                          updateTechHours(index, 'Premium_Sunday', e.target.value)
                                        }}
                                        value={tech?.Premium_Sunday === undefined ? 0 : tech.Premium_Sunday}
                                        disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                      />
                                  </Row>
                                </Col>
                            }
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    Premium Rate: <Form.Control
                                      style={{marginLeft:20,width:80}}
                                      type="number"
                                      min="0"
                                      onChange={(e)=>{
                                        updateTechHours(index, 'Premium Sunday Rate', e.target.value)
                                      }}
                                      value={tech?.["Premium Sunday Rate"] === undefined ? 0 : tech?.["Premium Sunday Rate"]}
                                      disabled={updateOrderButtonStatus === 'edit' ? true : false}
                                    />
                                  </Row>
                                </Col>
                            }
                            {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                                <Col>
                                  <Row>
                                    $: {((parseFloat(tech?.Sunday === "" || tech?.Sunday === undefined ? 0 : tech.Sunday) - parseFloat(tech?.Premium_Sunday === "" || tech?.Premium_Sunday === undefined ? 0 : tech.Premium_Sunday)) * parseFloat(tech?.["Sunday Rate"] === "" || tech?.["Sunday Rate"] === undefined ? 0 : tech["Sunday Rate"])) + (parseFloat(tech?.Premium_Sunday === "" || tech?.Premium_Sunday === undefined ? 0 : tech.Premium_Sunday) * parseFloat(tech?.["Premium Sunday Rate"] === "" || tech?.["Premium Sunday Rate"] === undefined ? 0 : tech["Premium Sunday Rate"]))}
                                  </Row>
                                </Col>
                            }
                          </Row>
                          {
                              props?.currentclientinfo?.client_info?.["Allow Premium Hours"] &&
                              <Row style={{margin: 5}}>Formula: ((Total Hours-Premium Hours)*Rate) + (Premium Hours * Premium Rate) = Total</Row>
                          }
                        </Row>
                      :
                        <div key={index}></div>
                    )
                  })
                }
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            className="btn-dark"
            style={{backgroundColor:"#2596be"}}
            onClick={()=>{
                setUpdateOrderButtonStatus('edit');
                setDisplayPrintOptions(false);
                props.onHide('show cancel', updateOrderButtonStatus);
            }}
          >
            {updateOrderButtonStatus === 'edit' ? "Close" : "Cancel and Close"}
          </Button>
        </Modal.Footer>
      </Modal>
    )
};

export default RequestModal;